/**
 * @description: 点歌系统设置
 * @author: hwx
 * @update: lyr(2022-03-02)
*/
<template>
    <div class="store-set-vod">
        <!-- 包厢后买单设置 -->
        <div class="store-room-set" v-show="show1">
            <div class="room-list">
                <h1 class="title">包厢后买单设置</h1>
                <div class="table-responsive">
                    <table id="roomList" class="table table-bordered table-hover" data-pagination="true" ref="roomList" style="margin-top:10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
            <div class="room-modify" ref="roomAlert">
                <p></p>
            </div>
        </div>


        <!-- 触摸屏wifi显示设置 -->
        <div class="store-wifi-set" v-show="show2">
            <div class="wifi-list" v-show="showWfList">
                <div class="row row-margin">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_wifi">wifi设置</button>
                </div>
                <h1 class="title">触摸屏wifi显示设置</h1>
                <p class="p-hint">注：设置后会在包厢触摸屏显示wifi账号和密码</p>
                <div class="table-responsive" style="padding: 0;">
                    <table id="wifiList" class="table table-bordered table-hover" data-pagination="true" ref="wifiList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
            <!-- 新增/修改 -->
            <div class="wifi-set" v-show="showWfSet">
                <div class="page-tit">{{wifi_header}}</div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用门店：</label>
                    <div class="col-md-4">
                        <select class="form-control select2" id="wifi_shop" ref="wifi_shop"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">显示序号：</label>
                    <div class="col-md-4">
                        <input class="form-control" placeholder="请输入显示序号，例如：01" v-model="wifi_listorder">
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">wifi名称：</label>
                    <div class="col-md-4">
                        <input class="form-control" placeholder="请输入wifi名称" v-model="wifi_name">
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">wifi密码：</label>
                    <div class="col-md-4">
                        <input class="form-control" placeholder="请输入wifi密码" v-model="wifi_psw">
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用包厢：</label>
                    <div class="col-md-4">
                        <input class="form-control input-readonly" placeholder="请选择适用包厢" v-model="wifi_box" ref="wifi_box" readonly="readonly" @click="go_wifi_box">
                        <span :class="wifi_objClass" @click="wifi_clear()">×</span>
                        <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
                    </div>
                </div>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backListWifi">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="wifiSub(wifiModify)">保存</button>
                </div>
            </div>
            <!-- 包厢号 -->
            <div class="box-page" ref="wifi_box_page" v-show="showWfBox">
                <div class="page-tit">选择包厢</div>
                <p>请选择包厢范围</p>
                <div class="box-main">
                    <div class="box-area">
                        <div class="first">
                            <input type="checkbox" v-model='wf_box_allcheck' @click='wfBoxAllcheck'>
                            <span>全部包厢</span>
                        </div>
                        <ul></ul>
                    </div>
                    <div class="box-area" v-for="(items, index) in wf_box_checkData" :key="items.room_area">
                        <div class="first">
                            <input type="checkbox" v-model='wf_box_flrModel' :value="items.room_area" @click="wfBoxFlr(items.room_area, index)">
                            <span>{{items.room_area_name}}</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in items.room" :key="item.id">
                                <input type="checkbox" v-model='wf_box_checkModel' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="wfBoxRtn()">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="wfBoxSubt()">确定</button>
                </div>
            </div>
        </div>


        <!-- 触摸屏屏保设置 -->
        <div class="store-scrn-set" v-show="show3">
            <div class="scrn-list" v-show="showScrnList">
                <div class="row row-margin">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_scrn">屏保设置</button>
                </div>
                <h1 class="title">触摸屏屏保</h1>
                <p class="p-hint">注：1、包厢点歌触摸屏屏保图片，在设定时间后无人操作触摸屏则自动轮播的屏保图片<br />2、触摸屏屏保设定时间可以直接在VOD参数自定义设置</p>
                <div class="table-responsive" style="padding: 0;">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="scrnList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
                </div>
            </div>
            <!-- 新增/修改 -->
            <div class="scrn-set" v-show="showScrnEdit">
                <div class="page-tit">{{scrn_header}}</div>
                <p>注：屏保是在包厢触摸屏无人操作180s后轮播图片。【横屏图片规范：尺寸1920*1080，竖屏图片规范：尺寸1080*1920 ，图片格式均为png，如您上传图片不符规范，将不能显示或被压缩】</p>
                <div class="row">
                    <label class="ctr-label-left">适用门店：</label>
                    <div class="col-md-4">
                        <select class="form-control select2" ref="scrn_shop"></select>
                    </div>
                </div>
                <div class="row">
                    <label class="ctr-label-left">适用包厢：</label>
                    <div class="col-md-4">
                        <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="scrn_room_txt" ref="scrn_room_txt" readonly @click="scrnRoomFun($event)">
                        <span class="selection-clear" @click="clearInput('scrn_room_txt')">×</span>
                        <span class="span-arrow"><b></b></span>
                    </div>
                </div>
                <div class="row">
                    <label class="ctr-label-left">优先级：</label>
                    <div class="col-md-4">
                        <input class="form-control" placeholder="请输入优先级" v-model="scrn_listorder">
                    </div>
                    <span class="rmarkspan" titles="数值大的优先" @mouseenter="openPbHint($event)" @mouseleave="closePbHint"></span>
                </div>
                <div class="row rowpadding clearfix">
                    <h4>横屏屏保：（<span>{{hp_num}}</span>/10张）</h4>
                    <ul class="scrn-hp-list">
                        <li v-for="(item, index) in scrn_imgs">
                            <img src="../../../assets/images/scrn_del.png" @click="delScrnHp(index)">
                            <div>
                                <img :class="item.cls" :src="item.link" @click="addimageFun(index)" @load="successLoadImg($event, index)" @error="errorLoadImg($event, index)">
                                <input type="file" class="uploadinput" @click="getScrnNum($event, index)" @change="uploadimgFun($event, index)" :ref="item.ids" :id="item.ids" :num="index" />
                            </div>
                            <span @click="bigHp(item.link)">查看大图</span>
                        </li>
                    </ul>
                    <img src="../../../assets/images/scrn_add_hp.png" class="scrn-hp-add" @click="addHpimg">
                </div>
                <div class="row rowpadding clearfix">
                    <h4>竖屏屏保：（<span>{{sp_num}}</span>/10张）</h4>
                    <ul class="scrn-sp-list">
                        <li v-for="(item, index) in scrn_sp_imgs">
                            <img src="../../../assets/images/scrn_del.png" @click="delScrnSp(index)">
                            <div>
                                <img :class="item.cls" :src="item.link" @click="addimgSpFun(index)">
                                <input type="file" class="uploadinput" @change="uploadSpimgFun($event, index)" :ref="item.ids" :id="item.ids" />
                            </div>
                            <span @click="bigSp(item.link)">查看大图</span>
                        </li>
                    </ul>
                    <img src="../../../assets/images/scrn_add_sp.png" class="scrn-sp-add" @click="addSpimg">
                </div>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backListScrn">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="scrnSub(scrnModify)">保存</button>
                </div>
            </div>
            <!-- 包厢号 -->
            <div class="multi-page" v-show="showScrnRoom">
                <div class="page-tit">选择包厢</div>
                <p>请选择包厢范围</p>
                <div class="multi-page-main">
                    <div class="multi-page-row">
                        <div>
                            <input type="checkbox" v-model='scrn_room_all' @click='scrnRoomAll'>
                            <span>全部</span>
                        </div>
                        <ul></ul>
                    </div>
                    <div class="multi-page-row" v-for="(items, index) in scrn_room_arr" :key="items.room_area">
                        <div>
                            <input type="checkbox" v-model='scrn_room_floor' :value="items.room_area" @click="scrnRoomFloor(items.room_area, index)">
                            <span>{{items.room_area_name}}</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in items.room" :key="item.id">
                                <input type="checkbox" v-model='scrn_room_item' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="scrnRoomBack()">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="scrnRoomSave()">确定</button>
                </div>
            </div>
        </div>
        <!-- 屏保设置 > 查看大图 横屏 -->
        <div class="big-hp" ref="big_hp">
            <img :src="big_hp_url" alt="">
        </div>
        <!-- 屏保设置 > 查看大图 竖屏 -->
        <div class="big-sp" ref="big_sp">
            <img :src="big_sp_url" alt="">
        </div>


        <!-- 触摸屏呼叫服务设置 -->
        <div class="store-chf-set" v-show="show4">
            <div class="chf-list">
                <h1 class="title">触摸屏呼叫服务设置</h1>
                <p class="p-hint">注：1 关闭后，触摸屏和微信端将不显示“呼叫服务“操作。2 开启后，可支持触摸屏和微信端设置快捷服务备注信息</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="chfList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(4)">返回</button>
                </div>
            </div>
            <div class="chf-modify">
                <div class="page-tit">呼叫服务设置</div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用门店：</label>
                    <div class="col-md-6 chf-modify-shop">
                        {{chf_shop_name}}
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">服务名称：</label>
                    <div class="chf-txt-add">
                        <div class="col-md-6">
                            <input class="form-control input-readonly" placeholder="请输入服务名称（10字以内），例如：冰块" maxlength="10" v-model="chf_name">
                        </div>
                        <img src="../../../assets/images/vod_add.png" @click="addChfName">
                    </div>
                    <div class="chf-txt-wrap" v-for="(item, index) in chf_name_lists">
                        <div class="col-md-6">
                            <input class="form-control input-readonly" placeholder="请输入服务名称（10字以内），例如：冰块" maxlength="10" v-model="item.name_model">
                        </div>
                        <img src="../../../assets/images/vod_del.png" @click="delChfName(index)">
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">参考名称：</label>
                    <div class="col-md-6 chf-sel-list">
                        <ul class="clearfix">
                            <li @click="addChfPre('冰块')">冰块</li>
                            <li @click="addChfPre('纸巾')">纸巾</li>
                            <li @click="addChfPre('酒杯')">酒杯</li>
                            <li @click="addChfPre('更换电池')">更换电池</li>
                            <li @click="addChfPre('清洁')">清洁</li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backChfList">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="chfSub()">确定</button>
                </div>
            </div>
        </div>


        <!-- disco限制播放时间设置 -->
        <div class="store-disco-set" v-show="show5">
            <div class="disco-list">
                <h1 class="title">disco限制播放时间设置</h1>
                <p>注：</p>
                <p>1、限制时间是开启时间到第二天08:00。</p>
                <p>2、开始时间设置成【无】指当前门店disco音乐播放不受时间限制，可以一直播放。</p>
                <p>例如：门店的disco音乐限时播放时间为23：00，开启时间设置成23：00即可。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="discoList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(5)">返回</button>
                </div>
            </div>
            <div class="disco-modify use-time-wrap" ref="discoAlert">
                <div>
                    <input type="checkbox" v-model="disco_time">
                    <label>无</label>
                </div>
                <select ref="discoHour"></select>
                <label class="colon">:</label>
                <select ref="discoSeconds"></select>
            </div>
        </div>


        <!-- 网关检测设置 -->
        <div class="store-wg-set" v-show="show6">
            <div class="wg-list">
                <h1 class="title">网关检测设置</h1>
                <p class="p-hint">注：如果包厢机获取的网关配置与该设置的值不一样，包厢机设置页面检测网络时会有文字提示警告。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="wgList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(6)">返回</button>
                </div>
            </div>
            <div class="wg-edit" ref="wg_edit">
                <div class="row rowpadding">
                    <label class="ct-label">门店：</label>
                    <div class="col-md-9">
                        <p>{{wg_shop}}</p>
                    </div>
                </div>
                <div class="row rowpadding">
                    <textarea placeholder="请输入ip地址" v-model="wg_ip"></textarea>
                </div>
            </div>
        </div>


        <!-- 触摸屏下单人员是否默认导购员设置 -->
        <div class="store-cmd-set" v-show="show7">
            <div class="cmd-list">
                <h1 class="title">触摸屏下单人员是否默认导购员设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="cmdList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(7)">返回</button>
                </div>
            </div>
        </div>


        <!-- 触摸屏点单推荐设置 -->
        <div class="store-order-set" v-show="show8">
            <div class="order-list" v-show="showDtjList">
                <el-row>
                    <el-button @click="backIndex(8)">返回</el-button>
                </el-row>
                <h1 class="title">触摸屏点单推荐设置</h1>
                <el-form :inline="true" :model="dtj_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="dtj_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="dtjTable(1)">查询</el-button>
                        <el-button type="primary" @click="dtjAdd">新增推荐</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="dtj_table">
                    <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                    <el-table-column prop="listorder" label="优先级"></el-table-column>
                    <el-table-column prop="room_names" label="适用包厢"></el-table-column>
                    <el-table-column label="适用日期">
                        <template slot-scope="scope">
                            {{scope.row.use_every_day == '1' ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                        </template>
                    </el-table-column>
                    <el-table-column label="适用时间段">
                        <template slot-scope="scope">
                            {{scope.row.start_time + '~' + scope.row.end_time}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                    <el-table-column prop="goods_num" label="图片"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="dtjModify(scope.row.id)">修改</span>
                            <span class="text-blue" @click="dtjDel(scope.row.id)">删除</span>
                            <span class="text-blue" @click="dtjStatus(scope.row)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dtj_page"
                    :total="dtj_total"
                    @current-change="dtjTable">
                </el-pagination>
            </div>
            <div class="dtj-edit" v-show="showDtjEdit">
                <h2>{{dtj_edit_tit}}</h2>
                <el-form :model="dtj_edit_form" label-width="120px">
                    <el-form-item label="门店">
                        <el-select v-model="dtj_edit_form.shop_id" filterable placeholder="请选择门店" @change="dtjShopChange">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="优先级">
                        <el-input placeholder="请输入规则优先级，数值大的优先" v-model="dtj_edit_form.listorder"></el-input>
                    </el-form-item>
                    <el-form-item label="适用包厢">
                        <el-input v-model="dtj_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="dtjRoomSelect" @clear="dtjRoomDel"></el-input>
                    </el-form-item>
                    <el-form-item label="适用日期" class="dtj-usedate-wrap">
                        <div ref="dtj_usedate_main" class="dtj-usedate-main">
                            <el-input v-model="dtj_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="适用时间段">
                        <el-input v-model="dtj_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="dtjUsetime"></el-input>
                    </el-form-item>
                    <el-form-item label="有效星期几">
                        <el-input v-model="dtj_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="dtjWeekSelect" @clear="dtjWeekDel"></el-input>
                    </el-form-item>
                    <el-form-item label="推荐设置">
                        <div v-for="(item, index) in dtj_edit_form.goods" :key="item.id" class="dtj-edit-goods">
                            <el-row>
                                <label class="el-form-item__label">图片</label>
                                <p>尺寸：1020*340，大小不超过5M</p>
                                <i class="el-icon-circle-plus" @click="dtjImgAdd" v-show="index==0"></i>
                                <i class="el-icon-remove" @click="dtjImgDel(index)" v-show="index!=0"></i>
                                <img :src="item.img" :id="item.img_id">
                            </el-row>
                            <el-row>
                                <label class="el-form-item__label">关联商品</label>
                                <el-input v-model="item.goods_name" class="el-ellipsis" clearable placeholder="请选择关联商品/商品套餐" @focus="dtjGoodsSelect(index)" @clear="dtjGoodsDel(index)"></el-input>
                            </el-row>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="dtjBackList">返回</el-button>
                        <el-button type="primary" @click="dtjEdit">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 包厢号 -->
            <div class="multi-page" v-show="showDtjRoom">
                <div class="page-tit">选择包厢</div>
                <p>请选择包厢范围</p>
                <div class="multi-page-main">
                    <div class="multi-page-row">
                        <div>
                            <input type="checkbox" v-model='dtj_room_all' @click='dtjRoomAll'>
                            <span>全部</span>
                        </div>
                        <ul></ul>
                    </div>
                    <div class="multi-page-row" v-for="(items, index) in dtj_room_arr" :key="items.room_area">
                        <div>
                            <input type="checkbox" v-model='dtj_room_floor' :value="items.room_area" @click="dtjRoomFloor(items.room_area, index)">
                            <span>{{items.room_area_name}}</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in items.room" :key="item.id">
                                <input type="checkbox" v-model='dtj_room_item' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="dtjRoomBack()">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="dtjRoomSave()">确定</button>
                </div>
            </div>
            <!-- 使用时间 -->
            <div class="use-time-wrap" ref="dtj_usetime_alert">
                <h2>开始时间：</h2>
                <el-row>
                    <el-col :span="11">
                        <el-select v-model="dtj_hour_start" filterable>
                            <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <el-col class="el-line" :span="2">:</el-col>
                    <el-col :span="11">
                        <el-select v-model="dtj_minute_start" filterable>
                            <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <h2>结束时间：</h2>
                <el-row>
                    <el-col :span="11">
                        <el-select v-model="dtj_hour_end" filterable>
                            <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <el-col class="el-line" :span="2">:</el-col>
                    <el-col :span="11">
                        <el-select v-model="dtj_minute_end" filterable>
                            <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <!-- 星期 -->
            <div class="export-wrap" ref="dtj_week_alert">
                <el-checkbox :indeterminate="dtj_week_sign" v-model="dtj_week_all" @change="dtjWeekAll">全选</el-checkbox>
                <el-checkbox-group v-model="dtj_week_ids" @change="dtjWeekChange">
                    <el-checkbox label="1">星期一</el-checkbox>
                    <el-checkbox label="2">星期二</el-checkbox>
                    <el-checkbox label="3">星期三</el-checkbox>
                    <el-checkbox label="4">星期四</el-checkbox>
                    <el-checkbox label="5">星期五</el-checkbox>
                    <el-checkbox label="6">星期六</el-checkbox>
                    <el-checkbox label="0">星期日</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 商品（套餐）弹窗 -->
            <div class="select-goods-wrap" ref="pop_goods_wrap">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-select v-model="pop_goods_type_name" clearable filterable placeholder="请选择类型" @change="popGoodsType">
                            <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="10">
                        <el-input placeholder="请输入商品名称" v-model="pop_goods_name"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button class="pull-right" type="primary" @click="popGoodsTable(1)">查询</el-button>
                    </el-col>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="pop_goods_table">
                    <el-table-column>
                        <template slot-scope="scope">
                            <el-radio v-model="pop_table_radio" :label="scope.$index" @change="popTableRow(scope.row)">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                    <el-table-column
                        v-for="(item, index) in pop_goods_columns"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label">
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZEMINI"
                    :current-page.sync="pop_goods_page"
                    :total="pop_goods_total"
                    @current-change="popGoodsTable">
                </el-pagination>
            </div>
        </div>

        <!-- 触摸屏点单热搜词设置 -->
        <div class="store-hot-search-set" v-show="show9">
            <div class="hot-search-list" v-show="showDrcList">
                <el-row>
                    <el-button @click="backIndex(9)">返回</el-button>
                </el-row>
                <h1 class="pos-title">触摸屏点单热搜词设置</h1>
                <el-form :inline="true" :model="drc_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="drc_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="drcTable(1)">查询</el-button>
                        <el-button type="primary" @click="drcAdd">新增热搜词</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="drc_table">
                    <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                    <el-table-column prop="listorder" label="优先级"></el-table-column>
                    <el-table-column prop="room_names" label="适用包厢"></el-table-column>
                    <el-table-column label="适用日期">
                        <template slot-scope="scope">
                            {{scope.row.use_every_day == '1' ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                        </template>
                    </el-table-column>
                    <el-table-column label="适用时间段">
                        <template slot-scope="scope">
                            {{scope.row.start_time + '~' + scope.row.end_time}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                    <el-table-column label="搜索词">
                        <template slot-scope="scope">
                            {{scope.row.keywords.join()}}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            {{scope.row.status == '1' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="drcModify(scope.row)">修改</span>
                            <span class="text-blue" @click="drcDel(scope.row.id)">删除</span>
                            <span class="text-blue" @click="drcStatus(scope.row)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="drc_page"
                    :total="drc_total"
                    @current-change="drcTable">
                </el-pagination>
            </div>
        </div>
        <div class="drc-edit" v-show="showDrcEdit">
            <h2>{{drc_edit_tit}}</h2>
            <el-form :model="drc_edit_form" label-width="120px">
                <el-form-item label="门店">
                    <el-select v-model="drc_edit_form.shop_id" filterable placeholder="请选择门店" @change="drcShopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="优先级">
                    <el-input placeholder="请输入规则优先级，数值大的优先" v-model="drc_edit_form.listorder"></el-input>
                </el-form-item>
                <el-form-item label="适用包厢">
                    <el-input v-model="drc_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="drcRoomSelect" @clear="drcRoomDel"></el-input>
                </el-form-item>
                <el-form-item label="适用日期" class="drc-usedate-wrap">
                    <div ref="drc_usedate_main" class="drc-usedate-main">
                        <el-input v-model="drc_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="适用时间段">
                    <el-input v-model="drc_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="drcUsetime"></el-input>
                </el-form-item>
                <el-form-item label="有效星期几">
                    <el-input v-model="drc_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="drcWeekSelect" @clear="drcWeekDel"></el-input>
                </el-form-item>
                <el-form-item label="搜索词设置">
                    <el-row v-for="(item, index) in drc_edit_form.keywords" :key="index" class="drc-edit-goods">
                        <el-input placeholder="请输入搜索词名称" v-model="drc_edit_form.keywords[index]"></el-input>
                        <i class="el-icon-circle-plus" @click="drcImgAdd" v-show="index==0"></i>
                        <i class="el-icon-remove" @click="drcImgDel(index)" v-show="index!=0"></i>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button @click="drcBackList">返回</el-button>
                    <el-button type="primary" @click="drcEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 包厢号 -->
        <div class="multi-page" v-show="showDrcRoom">
            <div class="page-tit">选择包厢</div>
            <p>请选择包厢范围</p>
            <div class="multi-page-main">
                <div class="multi-page-row">
                    <div>
                        <input type="checkbox" v-model='drc_room_all' @click='drcRoomAll'>
                        <span>全部</span>
                    </div>
                    <ul></ul>
                </div>
                <div class="multi-page-row" v-for="(items, index) in drc_room_arr" :key="items.room_area">
                    <div>
                        <input type="checkbox" v-model='drc_room_floor' :value="items.room_area" @click="drcRoomFloor(items.room_area, index)">
                        <span>{{items.room_area_name}}</span>
                    </div>
                    <ul class="clearfix">
                        <li v-for="item in items.room" :key="item.id">
                            <input type="checkbox" v-model='drc_room_item' :value="item.id">
                            <span>{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="drcRoomBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="drcRoomSave()">确定</button>
            </div>
        </div>
        <!-- 使用时间 -->
        <div class="use-time-wrap" ref="drc_usetime_alert">
            <h2>开始时间：</h2>
            <el-row>
                <el-col :span="11">
                    <el-select v-model="drc_hour_start" filterable>
                        <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
                <el-col class="el-line" :span="2">:</el-col>
                <el-col :span="11">
                    <el-select v-model="drc_minute_start" filterable>
                        <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <h2>结束时间：</h2>
            <el-row>
                <el-col :span="11">
                    <el-select v-model="drc_hour_end" filterable>
                        <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
                <el-col class="el-line" :span="2">:</el-col>
                <el-col :span="11">
                    <el-select v-model="drc_minute_end" filterable>
                        <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>
        <!-- 星期 -->
        <div class="export-wrap" ref="drc_week_alert">
            <el-checkbox :indeterminate="drc_week_sign" v-model="drc_week_all" @change="drcWeekAll">全选</el-checkbox>
            <el-checkbox-group v-model="drc_week_ids" @change="drcWeekChange">
                <el-checkbox label="1">星期一</el-checkbox>
                <el-checkbox label="2">星期二</el-checkbox>
                <el-checkbox label="3">星期三</el-checkbox>
                <el-checkbox label="4">星期四</el-checkbox>
                <el-checkbox label="5">星期五</el-checkbox>
                <el-checkbox label="6">星期六</el-checkbox>
                <el-checkbox label="0">星期日</el-checkbox>
            </el-checkbox-group>
        </div>

        <!-- 触摸屏包厢账单是否显示送花结账单 -->
        <div class="store-show-flower-set" v-show="show10">
            <div class="flower-list">
                <h1 class="title">触摸屏包厢账单是否显示送花结账单</h1>
                <p class="p-hint">注：设置“是”，则包厢触摸屏端-我的账单内容显示含送花结账单信息</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="flowerList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(10)">返回</button>
                </div>
            </div>
        </div>

        <!-- 大厅自助台球语音播报设置 -->
         <div class="store-ball-voice-set" v-show="show11">
            <div class="ball-voice-list" v-show="show11_list">
                <h1 class="title">大厅自助台球语音播报设置</h1>
                <el-button @click="backIndex(11)">返回</el-button>
                <el-table :data="ball_voice_table" style="width: 100%">
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="self_service_billiards_setting.audio_broadcast_status" label="语音播报">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.self_service_billiards_setting.audio_broadcast_status" @change="ballVoiceChange(scope.row)">
                                <el-option label="开启" value="1"></el-option>
                                <el-option label="关闭" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" label="播放设备">
                        <template slot-scope="scope">
                            <el-button type="text" @click="ballDeviceEdit(scope.row)">设置</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" label="播放内容">
                        <template slot-scope="scope">
                            <el-button type="text" @click="ballContentEdit(scope.row)">设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination 
                    background 
                    layout="total, prev, pager, next, jumper" 
                    :page-size="10"
                    :current-page.sync="ball_voice_page" 
                    :total="ball_voice_total" 
                    @current-change="ballVoiceTable">
                    </el-pagination>
            </div>
            <div class="ball-voice-list" v-show="show11_device">
                <div class="ball-voice-list-header">
                    <h1>选择播放设备</h1>
                </div>
                <el-radio-group>
                    <el-radio label="1" disabled>包厢机顶盒</el-radio>
                </el-radio-group>
                <div class="room-selection">
                    <h3 class="room-selection-title">选择机顶盒设备</h3>
                    <el-radio-group v-model="selected_row.self_service_billiards_setting.audio_play_device" class="room-radio-group">
                        <el-radio 
                            v-for="room in room_list" 
                            :key="room.id"
                            :label="room.id"
                            class="room-radio-item">
                            {{ room.name }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <el-button @click="backToList">返回</el-button>
                <el-button type="primary" @click="ballVoiceDeviceSave">确定</el-button>
            </div>
            <div class="ball-voice-list" v-show="show11_content">
                <h1>播放内容设置</h1>
                <div class="ball-voice-content-list">
                    <h2>播放音量</h2>
                    <el-input style="width: 300px;" v-model="selected_row.self_service_billiards_setting.audio_content.volume" placeholder="请输入播放音量"></el-input>
                </div>
                <!-- 开台播报 -->
                <div class="ball-voice-content-item">
                    <div class="ball-voice-content-item-header">
                        <div>开台播报</div>
                        <el-radio-group v-model="selected_row.self_service_billiards_setting.audio_content.open_audio_status">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="-1">关闭</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="ball-voice-content-item-content">
                        <el-input type="textarea" size="small" :rows="8" style="width: 670px;" v-model="selected_row.self_service_billiards_setting.audio_content.open_audio_content" placeholder="请输入开台播报内容"></el-input>
                    </div>
                    <div class="ball-voice-content-item-footer">
                        <div>选择变量</div>
                        <div>
                            <el-button type="primary" plain size="small" @click="addVariable('{room_name}', 'open_audio_content')">#包厢号</el-button>
                            <el-button type="primary" plain size="small" @click="addVariable('{shop_name}', 'open_audio_content')">#门店名称</el-button>
                            <el-button type="primary" plain size="small" @click="addVariable('{total_time}', 'open_audio_content')">#消费时长</el-button>
                        </div>
                    </div>
                </div>
                <!-- 续费播报 -->
                <div class="ball-voice-content-item">
                    <div class="ball-voice-content-item-header">
                        <div>续费提醒播报</div>
                        <el-radio-group v-model="selected_row.self_service_billiards_setting.audio_content.renewal_audio_status">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="-1">关闭</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="ball-voice-content-item-content">
                        <div class="renewal-time-settings">
                            <div class="renewal-time-label">结束前多久提醒</div>
                            <div class="renewal-time-options">
                                <el-checkbox-group v-model="selected_row.self_service_billiards_setting.audio_content.renewal_audio_time">
                                    <el-checkbox :label="30">30分钟</el-checkbox>
                                    <el-checkbox :label="20">20分钟</el-checkbox>
                                    <el-checkbox :label="15">15分钟</el-checkbox>
                                    <el-checkbox :label="10">10分钟</el-checkbox>
                                    <el-checkbox :label="5">5分钟</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <el-input type="textarea" size="small" :rows="8" style="width: 670px;" v-model="selected_row.self_service_billiards_setting.audio_content.renewal_audio_content" placeholder="请输入续费播报内容"></el-input>
                    </div>
                    <div class="ball-voice-content-item-footer">
                        <div>选择变量</div>
                        <div>
                            <el-button type="primary" plain size="small" @click="addVariable('{room_name}', 'renewal_audio_content')">#包厢号</el-button>
                            <el-button type="primary" plain size="small" @click="addVariable('{shop_name}', 'renewal_audio_content')">#门店名称</el-button>
                            <el-button type="primary" plain size="small" @click="addVariable('{remaining_time}', 'renewal_audio_content')">#结束前多久</el-button>
                        </div>
                    </div>
                </div>
                <!-- 关台播报 -->
                <div class="ball-voice-content-item">
                    <div class="ball-voice-content-item-header">
                        <div>关台播报</div>
                        <el-radio-group v-model="selected_row.self_service_billiards_setting.audio_content.close_audio_status">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="-1">关闭</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="ball-voice-content-item-content">
                        <el-input type="textarea" size="small" :rows="8" style="width: 670px;" v-model="selected_row.self_service_billiards_setting.audio_content.close_audio_content" placeholder="请输入关台播报内容"></el-input>
                    </div>
                    <div class="ball-voice-content-item-footer">
                        <div>选择变量</div>
                        <div>
                            <el-button type="primary" plain size="small" @click="addVariable('{room_name}', 'close_audio_content')">#包厢号</el-button>
                            <el-button type="primary" plain size="small" @click="addVariable('{shop_name}', 'close_audio_content')">#门店名称</el-button>
                        </div>
                    </div>
                </div>
                <el-button @click="backToList">返回</el-button>
                <el-button type="primary" @click="ballVoiceContentSave">确定</el-button>
            </div>
         </div>

        <!-- 播放设备设置提示弹窗 -->
        <div class="device-modal-overlay" v-if="showDeviceModal" @click="closeDeviceModal">
            <div class="device-modal" @click.stop>
                <div class="device-modal-header">
                    <h3>提示</h3>
                </div>
                <div class="device-modal-body">
                    <p>当前未设置播放设备,请先设置播</p>
                    <p>放设备!</p>
                </div>
                <div class="device-modal-footer">
                    <button class="device-modal-btn device-modal-btn-cancel" @click="closeDeviceModal">取消</button>
                    <button class="device-modal-btn device-modal-btn-confirm" @click="goToDeviceSetting">前往设置</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                show6: false,
                show7: false,
                show8: false,
                show9: false,
                show10: false,
                show11: false,

                // 触摸屏wifi显示设置
                showWfList: true,
                showWfSet: false,
                showWfBox: false,
                wifi_header: "",
                wifiModify: "1",
                wifi_listorder: "",
                wifi_name: "",
                wifi_psw: "",
                wifi_box: "",
                wifi_objClass: {
                    visi_hid: true,
                    selection_clear: true
                },
                wf_box_allcheck: false,
                wf_c_box_allcheck: false,
                wf_box_flrModel: [],
                wf_c_box_flrModel: [],
                wf_box_checkModel: [],
                wf_temp_box_checkModel: [],
                wf_box_checkData: [],
                wf_box_detCheckData: [],
                wf_rooms: [],
                is_all: '-1',
                wf_det: [],

                // 触摸屏屏保设置
                showScrnList: true,
                showScrnEdit: false,
                scrnModify: "1",
                scrn_header: '新增屏保',
                hp_num: 0,
                scrn_imgs: [],
                scrnIndex: '',
                scrnEvent: '',
                sp_num: 0,
                scrn_sp_imgs: [],
                scrn_det: [],
                big_hp_url: '',
                big_sp_url: '',
                showScrnRoom: false,
                scrn_room_txt: '',
				scrn_room_all: false,
				c_scrn_room_all: false,
				scrn_all_rooms: '-1',
                scrn_all_shops: '1',
				scrn_room_floor: [],
				c_scrn_room_floor: [],
				scrn_room_item: [],
				c_scrn_room_item: [],
				scrn_room_arr: [],
                scrn_room_arr_det: [],
                scrn_listorder: '',

                // 触摸屏呼叫服务设置
                chf_shop_id: '',
                chf_shop_name: '',
                chf_auto_receive: [],
                chf_name: '',
                chf_name_lists: [],

                // disco限制播放时间设置
                disco_time: '',

                // 网关检测设置
                wg_shop: '',
                wg_ip: '',

                // 触摸屏点单推荐设置
                loading: false,
                showDtjList: true,
                showDtjEdit: false,
                showDtjRoom: false,
                dtj_list_form: {
                    shop_id: ''
                },
                shop_list: [],
                week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
                dtj_page: 1,
                dtj_total: 0,
                dtj_table: [],
                dtj_edit_id: '',
                dtj_edit_tit: '',
                dtj_edit_form: {
                    shop_id: '',
                    listorder: '',
                    goods: [{
                        img: require('../../../assets/images/upload_btn.png'),
                        img_id: 'dtjImg0',
                        img_done: false,
                        type: '',
                        goods_id: '',
                        goods_name: ''
                    }]
                },
                dtj_room_txt: '',
                dtj_use_all_room: -1,
                dtj_room_all: false,
                dtj_room_item: [],
                dtj_c_room_item: [],
                dtj_room_floor: [],
                dtj_room_arr: [],
                dtj_room_arr_det: [],
                dtj_usedate_txt: '',
                dtj_use_every_day: -1,
                dtj_usedate_start: '',
                dtj_usedate_end: '',
                dtj_usetime_txt: '',
                dtj_usetime_start: '',
                dtj_usetime_end: '',
                dtj_hour_start: '00',
                dtj_minute_start: '00',
                dtj_hour_end: '00',
                dtj_minute_end: '00',
                dtj_week_txt: '',
                dtj_week_sign: false,
                dtj_week_all: false,
                dtj_week_ids: [],
                // 商品（套餐）弹窗
                pop_goods_shop_id: '',
                pop_goods_type_id: '',
                pop_goods_type_name: '',
                pop_goods_type_sign: '',
                goods_type_list: [{
                    id: "-2",
                    name: "商品套餐",
                    type: 'package',
                    type_id: ''
                }],
                pop_goods_name: '',
                pop_table_radio: '',
                pop_table_select: {},
                pop_goods_page: 1,
                pop_goods_total: 0,
                pop_goods_table: [],
                pop_goods_columns: [],

                // 触摸屏点单热搜词设置
                showDrcList: true,
                showDrcEdit: false,
                showDrcRoom: false,
                drc_list_form: {
                    shop_id: ''
                },
                drc_page: 1,
                drc_total: 0,
                drc_table: [],
                drc_edit_id: '',
                drc_edit_tit: '',
                drc_edit_form: {
                    shop_id: '',
                    listorder: '',
                    keywords: ['']
                },
                drc_room_txt: '',
                drc_use_all_room: -1,
                drc_room_all: false,
                drc_room_item: [],
                drc_c_room_item: [],
                drc_room_floor: [],
                drc_room_arr: [],
                drc_room_arr_det: [],
                drc_usedate_txt: '',
                drc_use_every_day: -1,
                drc_usedate_start: '',
                drc_usedate_end: '',
                drc_usetime_txt: '',
                drc_usetime_start: '',
                drc_usetime_end: '',
                drc_hour_start: '00',
                drc_minute_start: '00',
                drc_hour_end: '00',
                drc_minute_end: '00',
                drc_week_txt: '',
                drc_week_sign: false,
                drc_week_all: false,
                drc_week_ids: [],

                // 大厅自助台球语音播报设置
                ball_voice_table: [],
                ball_voice_total: 0,
                ball_voice_page: 1,
                show11_list: true,
                show11_device: false,
                show11_content: false,
                // 包厢列表
                room_list: [],
                selected_row: {
                    self_service_billiards_setting:{
                        audio_broadcast_status: "-1", // 语音播报，1：开启，-1：关闭
                        audio_play_device: "36", // 语音播报播放设备，包厢id
                        audio_content: { // 语音播放内容设置
                            volume: "50", // 音量
                            open_audio_status: "1", // 开台播报，1：开启，-1：关闭
                            open_audio_content: "欢迎来到{shop_name}，您已成功开启{room_name}号台", // 开台播报内容
                            renewal_audio_status: "1", // 续费播报，1：开启，-1：关闭
                            renewal_audio_time: [10,5], // 剩余时间提醒，多选，数组
                            renewal_audio_content: "温馨提示:您使用的{room_name}号台,剩余游戏时间不足{remaining_time},请合理安排局数,准备离场。如需续时,请扫描桌面二维码,感谢您的使用,祝您打球愉快", // 续费播报内容
                            close_audio_status: "1", // 关台播报，1：开启，-1：关闭
                            close_audio_content: "温馨提示:您使用的{room_name}号台,游戏时间已结束。感谢您的使用,欢迎再次光临{shop_name}" // 关台播报内容
                        }
                    },
                },
                // 播放设备设置弹窗
                showDeviceModal: false,
                currentRow: null,
            }
        },
        watch: {
            // 触摸屏wifi显示设置
            wf_box_checkModel: {
                handler: function(val, oldVal) {
                    let _this = this;

                    if(this.wf_box_checkModel.length >= this.wf_box_detCheckData.length) {
                        this.wf_box_allcheck = true;
                        this.wf_c_box_allcheck = true;
                    } else {
                        this.wf_box_allcheck = false;
                        this.wf_c_box_allcheck = false;
                    }
                    $.each(_this.wf_box_checkData, function(k, v) {
                        if(_this.wf_box_checkModel.length >= v.room.length) {
                            let num = 0;
                            for(let i = 0, len = v.room.length; i < len; i++) {
                                if(_this.wf_box_checkModel.indexOf(v.room[i].id) != -1) {
                                    num++;
                                }
                                if(i == v.room.length - 1 && num == v.room.length) {
                                    if(_this.wf_box_flrModel.indexOf(v.room_area) == -1) {
                                        _this.wf_box_flrModel.push(v.room_area);
                                    }
                                } else {
                                    let index = '';
                                    index = _this.wf_box_flrModel.indexOf(v.room_area);
                                    if(index != -1) {
                                        _this.wf_box_flrModel.splice(index, 1);
                                    }
                                }
                            }
                        } else {
                            let index = '';
                            index = _this.wf_box_flrModel.indexOf(v.room_area);
                            if(index != -1) {
                                _this.wf_box_flrModel.splice(index, 1);
                            }
                        }
                    });
                    _this.wf_c_box_flrModel = _this.wf_box_flrModel;
                },
                deep: true
            },

            // 触摸屏屏保设置
            scrn_room_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.scrn_room_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.scrn_room_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			scrn_room_item: {
				handler: function(val, oldVal) {
					let _this = this;

					if(_this.scrn_room_item.length >= _this.scrn_room_arr_det.length) {
						_this.scrn_room_all = true;
						_this.c_scrn_room_all = _this.scrn_room_all;
					} else {
						_this.scrn_room_all = false;
						_this.c_scrn_room_all = _this.scrn_room_all;
					}

					$.each(_this.scrn_room_arr, function(k, v) {
						if(_this.scrn_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.scrn_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.scrn_room_floor.indexOf(v.room_area) == -1) {
										_this.scrn_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.scrn_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.scrn_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.scrn_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.scrn_room_floor.splice(index, 1);
							}
						}
					});
					_this.c_scrn_room_floor = _this.scrn_room_floor;
				},
				deep: true
			},
            
            // disco限制播放时间设置
            disco_time: {
                handler: function(val, oldVal) {
                    if(this.disco_time) {
                        $(this.$refs.discoHour).attr('disabled', true);
                        $(this.$refs.discoSeconds).attr('disabled', true);
                    } else {
                        $(this.$refs.discoHour).attr('disabled', false);
                        $(this.$refs.discoSeconds).attr('disabled', false);
                    }
                },
                deep: true
            },

            // 点单推荐设置
            dtj_room_item: {
                handler: function(val, oldVal) {
                    const _this = this;

                    if(_this.dtj_room_item.length >= _this.dtj_room_arr_det.length) {
                        _this.dtj_room_all = true;
                    } else {
                        _this.dtj_room_all = false;
                    }

                    $.each(_this.dtj_room_arr, function(k, v) {
                        if(_this.dtj_room_item.length >= v.room.length) {
                            let num = 0;
                            for(let i = 0, len = v.room.length; i < len; i++) {
                                if(_this.dtj_room_item.indexOf(v.room[i].id) != -1) {
                                    num++;
                                }
                                if(i == v.room.length - 1 && num == v.room.length) {
                                    if(_this.dtj_room_floor.indexOf(v.room_area) == -1) {
                                        _this.dtj_room_floor.push(v.room_area);
                                    }
                                } else {
                                    let index = '';
                                    index = _this.dtj_room_floor.indexOf(v.room_area);
                                    if(index != -1) {
                                        _this.dtj_room_floor.splice(index, 1);
                                    }
                                }
                            }
                        } else {
                            let index = '';
                            index = _this.dtj_room_floor.indexOf(v.room_area);
                            if(index != -1) {
                                _this.dtj_room_floor.splice(index, 1);
                            }
                        }
                    });
                },
                deep: true
            },

            // 点单热搜词设置
            drc_room_item: {
                handler: function(val, oldVal) {
                    const _this = this;

                    if(_this.drc_room_item.length >= _this.drc_room_arr_det.length) {
                        _this.drc_room_all = true;
                    } else {
                        _this.drc_room_all = false;
                    }

                    $.each(_this.drc_room_arr, function(k, v) {
                        if(_this.drc_room_item.length >= v.room.length) {
                            let num = 0;
                            for(let i = 0, len = v.room.length; i < len; i++) {
                                if(_this.drc_room_item.indexOf(v.room[i].id) != -1) {
                                    num++;
                                }
                                if(i == v.room.length - 1 && num == v.room.length) {
                                    if(_this.drc_room_floor.indexOf(v.room_area) == -1) {
                                        _this.drc_room_floor.push(v.room_area);
                                    }
                                } else {
                                    let index = '';
                                    index = _this.drc_room_floor.indexOf(v.room_area);
                                    if(index != -1) {
                                        _this.drc_room_floor.splice(index, 1);
                                    }
                                }
                            }
                        } else {
                            let index = '';
                            index = _this.drc_room_floor.indexOf(v.room_area);
                            if(index != -1) {
                                _this.drc_room_floor.splice(index, 1);
                            }
                        }
                    });
                },
                deep: true
            },
        },
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitRoomTable()
                } else if(num == '2') {
                    this.innitWifiTable()
                    this.getShopData('wifi')
                } else if(num == '3') {
                    this.innitScrnTable()
                    this.getShopData('scrn')
                } else if(num == '4') {
                    this.innitChfTable()
                } else if(num == '5') {
                    this.innitDiscoTable()
                } else if(num == '6') {
                    this.innitWgTable()
                } else if(num == '7') {
                    this.innitCmdTable()
                } else if(num == '8') {
                    this.getShop('8')
                } else if(num == '9') {
                    this.getShop('9')
                } else if(num == '10') {
                    this.innitFlowerTable()
                } else if(num == '11') {
                    this.ballVoiceTable(1)
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },
            // 获取门店数据
            getShopData: function(name) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });

                            if(name == 'wifi') {
                                $(_this.$refs.wifi_shop).html("");
                                $(_this.$refs.wifi_shop).select2({
                                    data: arr,
                                    minimumResultsForSearch: -1,
                                    language: "zh-CN",
                                    width: '100%'
                                }).on("select2:select", function(e) {
                                    _this.wf_box_checkModel = [];
                                    _this.wifi_box = '';
                                    _this.getWifiBox(e.params.data.id);
                                });
                            } else if(name == 'scrn') {
                                $(_this.$refs.scrn_shop).html("");
                                $(_this.$refs.scrn_shop).select2({
                                    data: arr,
                                    minimumResultsForSearch: -1,
                                    language: "zh-CN",
                                    width: '100%'
                                }).on("select2:select",function(e) {
                                    console.log('eeee',e);
                                    if(e.params.data.id != '0'){
                                        // 包厢号
                                        _this.getScrnRoom(e.params.data.id);
                                        _this.scrn_room_txt = '';
                                        _this.scrn_all_rooms = '-1';
                                        _this.scrn_room_item = [];
                                        _this.scrn_all_shops = '-1';
                                    }else{
                                        _this.scrn_room_txt = '全部';
                                        _this.scrn_all_rooms = '1';
                                        _this.scrn_room_item = [];
                                        _this.scrn_all_shops = '1';
                                    }
                                    
                                });
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },


            /*
             * 包厢后买单设置
             */
            // 初始化包厢后买单列表
            innitRoomTable: function() {
                let _this = this;
                $(_this.$refs.roomList).bootstrapTable('destroy');
                $(_this.$refs.roomList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getRoomList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "序号",
                        width: "10%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "pay_after_name",
                        title: "包厢后买单",
                        width: "30%"
                    }, {
                        title: "操作",
                        width: "30%",
                        events: {
                            'click .modify': function(e, value, row) {
                                if(row.pay_after == '1') {
                                    $('.room-modify p').text('确定将' + row.shop_name + '包厢后买单改成“关闭”？');
                                } else if(row.pay_after == '-1') {
                                    $('.room-modify p').text('确定将' + row.shop_name + '包厢后买单改成“开启”？');
                                }
                                _this.openRoomModify(row);
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // 包厢后买单列表
            getRoomList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getShopPayAfterSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 包厢后买单弹窗、修改
            openRoomModify: function(row) {
                let _this = this;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['修改', true],
                    area: ['350px', ''], // 宽高
                    content: $(_this.$refs.roomAlert)
                }, function() {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": row.shop_id
                            }
                        },
                        "comment": ""
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "shop/setShopPayAfterStatus",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.closeAll();
                                layer.msg(data.response.error_msg);
                                $(_this.$refs.roomList).bootstrapTable("refresh");
                            } else {
                                layer.closeAll();
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },


            /*
             * 触摸屏wifi显示设置
             */
            // wifi设置列表
            innitWifiTable: function() {
                let _this = this;
                $(_this.$refs.wifiList).bootstrapTable('destroy');
                $(_this.$refs.wifiList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getWifiList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "listorder",
                        title: "显示序号",
                        width: "10%"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "18%"
                    }, {
                        field: "room_names",
                        title: "适用包厢",
                        width: "18%"
                    }, {
                        field: "name",
                        title: "wifi名称",
                        width: "18%"
                    }, {
                        field: "password",
                        title: "wifi密码",
                        width: "18%"
                    }, {
                        title: "操作",
                        width: "18%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.wifi_header = '修改wifi设置';
                                _this.wifiModify = 2;
                                _this.getWifiDet(row.id);
                                _this.showWfList = false;
                                _this.showWfSet = true;
                            },
                            'click .delete': function(e, value, row) {
                                layer.confirm('删除后不可恢复，确定删除吗？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.delWifi(row.id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                        }
                    }]
                });
            },
            // wifi设置数据
            getWifiList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getWifiList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击wifi设置
            add_wifi: function() {
                this.wifi_header = '新增wifi设置';
                // 门店
                $(this.$refs.wifi_shop).val('').trigger('change');
                $(this.$refs.wifi_shop).prop('disabled', false);

                this.wifiModify = 1;
                this.wifi_listorder = "";
                this.wifi_name = "";
                this.wifi_psw = "";
                this.wf_box_flrModel = [];
                this.wf_box_checkModel = [];
                this.wf_rooms = [];
                this.wifi_box = '';
                this.getWifiBox($(this.$refs.wifi_shop).val());
                this.showWfList = false;
                this.showWfSet = true;
                this.showWfBox = false;
            },
            // 包厢号数据
            getWifiBox: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoomByArea",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.wf_box_checkData = data['response']['result'];
                            let newarray = [];
                            $.each(data['response']['result'], function(k, v) {
                                $.each(v.room, function(m, n) {
                                    newarray.push(n);
                                });
                            });
                            _this.wf_box_detCheckData = newarray;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 点击选择包厢号
            go_wifi_box: function() {
                let _this = this;
                _this.wf_temp_box_checkModel = [];
                $.each(_this.wf_box_checkModel, function(k, v) {
                    _this.wf_temp_box_checkModel.push(v);
                });
                // _this.wf_temp_box_flrModel = _this.wf_box_flrModel;
                this.showWfSet = false;
                this.showWfBox = true;
            },
            // 返回
            wfBoxRtn: function() {
                let _this = this;
                _this.wf_box_checkModel = _this.wf_temp_box_checkModel;
                // _this.wf_box_flrModel = _this.wf_temp_box_flrModel;
                this.showWfSet = true;
                this.showWfBox = false;
            },
            // 确定包厢号
            wfBoxSubt: function() {
                let _this = this;

                if(_this.wf_box_allcheck) {
                    _this.wifi_box = '全部';
                    _this.is_all = '1';
                } else {
                    let texts = [];
                    _this.wf_box_detCheckData.forEach(function(item) {
                        _this.wf_box_checkModel.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.wifi_box = texts.join(",");
                    _this.is_all = '-1';
                }
                _this.showWfSet = true;
                _this.showWfBox = false;

                // 拼接选中的包厢id wf_rooms
                _this.wf_rooms = [];
                if(_this.wf_box_flrModel.length == '0') {
                    $.each(_this.wf_box_checkData, function(k, v) {
                        $.each(v.room, function(x, y) {
                            let index = _this.wf_box_checkModel.indexOf(y.id);
                            if(index != -1) {
                                _this.wf_rooms.push({'type': 1, 'room_id': _this.wf_box_checkModel[index]});
                            }
                        });
                    });
                } else {
                    $.each(_this.wf_box_flrModel, function(k, v) {
                        _this.wf_rooms.push({'type': 2, 'room_id': v});
                    });
                    if(_this.wf_box_flrModel.length < _this.wf_box_checkData.length) {
                        $.each(_this.wf_box_checkData, function(k, v) {
                            if(_this.wf_box_flrModel.indexOf(v.room_area) == '-1') {
                                $.each(v.room, function(x, y) {
                                    let index = _this.wf_box_checkModel.indexOf(y.id);
                                    if(index != -1) {
                                        _this.wf_rooms.push({'type': 1, 'room_id': _this.wf_box_checkModel[index]});
                                    }
                                });
                            }
                        });
                    }
                }
            },
            // 全选
            wfBoxAllcheck: function() {
                var _this = this;
                _this.wf_box_allcheck = _this.wf_c_box_allcheck;
                if(!_this.wf_box_allcheck) { // 实现全选
                    _this.wf_box_checkModel = [];
                    _this.wf_box_detCheckData.forEach(function(item) {
                        _this.wf_box_checkModel.push(item.id);
                    });
                } else { // 实现反选
                    this.wf_box_checkModel = [];
                }
            },
            // 楼层全选/反选
            wfBoxFlr: function(id, index) {
                let _this = this;
                _this.wf_box_flrModel = _this.wf_c_box_flrModel;
                if(_this.wf_box_flrModel.indexOf(id) == -1) {
                    $.each(_this.wf_box_checkData[index].room, function(k, v) {
                        if(_this.wf_box_checkModel.indexOf(v.id) == -1) {
                            _this.wf_box_checkModel.push(v.id);
                        }
                    });
                } else {
                    $.each(_this.wf_box_checkData[index].room, function(k, v) {
                        let index = '';
                        index = _this.wf_box_checkModel.indexOf(v.id);
                        if(index != -1) {
                            _this.wf_box_checkModel.splice(index, 1);
                        }
                    });
                }
            },
            // 获取详情数据
            getWifiDet: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getWifiDetail",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.wf_det = data.response.result;
                            $(_this.$refs.wifi_shop).val(_this.wf_det.shop_id).trigger('change');
                            $(_this.$refs.wifi_shop).prop('disabled', true);
                            _this.wifi_listorder = _this.wf_det.listorder;
                            _this.wifi_name = _this.wf_det.name;
                            _this.wifi_psw = _this.wf_det.password;
                            // 包厢号
                            _this.getWifiBox(_this.wf_det.shop_id);
                            _this.wf_box_flrModel = [];
                            _this.wf_box_checkModel = [];
                            if(_this.wf_det.is_all == '1') {
                                _this.wifi_box = '全部';
                                _this.is_all = '1';
                                _this.wf_box_checkData.forEach(function(item) {
                                    _this.wf_box_flrModel.push(item.room_area);
                                });
                                _this.wf_box_detCheckData.forEach(function(item) {
                                    _this.wf_box_checkModel.push(item.id);
                                });
                            } else {
                                _this.wifi_box = _this.wf_det.room_names;
                                _this.is_all = '-1';
                                $.each(_this.wf_det.rooms, function(k, v) {
                                    if(v.type == '1') {
                                        _this.wf_box_checkModel.push(v.room_id);
                                    } else {
                                        // _this.wf_box_flrModel.push(v.room_id);
                                        // let index = _this.wf_box_checkData.indexOf(v.room_id);
                                        $.each(_this.wf_box_checkData, function(m, n) {
                                            if(n.room_area == v.room_id) {
                                                _this.wf_box_flrModel.push(n.room_area);
                                                $.each(n.room, function(x, y) {
                                                    _this.wf_box_checkModel.push(y.id);
                                                });
                                            }
                                        });
                                        // _this.wf_box_checkData[k].room.forEach(function(item) {
                                        //     _this.wf_box_checkModel.push(item.id);
                                        // });
                                    }
                                });
                            }

                            // 拼接选中的包厢id wf_rooms
                            _this.wf_rooms = [];
                            if(_this.wf_box_flrModel.length == '0') {
                                $.each(_this.wf_box_checkData, function(k, v) {
                                    $.each(v.room, function(x, y) {
                                        let index = _this.wf_box_checkModel.indexOf(y.id);
                                        if(index != -1) {
                                            _this.wf_rooms.push({'type': 1, 'room_id': _this.wf_box_checkModel[index]});
                                        }
                                    });
                                });
                            } else {
                                $.each(_this.wf_box_flrModel, function(k, v) {
                                    _this.wf_rooms.push({'type': 2, 'room_id': v});
                                });
                                if(_this.wf_box_flrModel.length < _this.wf_box_checkData.length) {
                                    $.each(_this.wf_box_checkData, function(k, v) {
                                        if(_this.wf_box_flrModel.indexOf(v.room_area) == '-1') {
                                            $.each(v.room, function(x, y) {
                                                let index = _this.wf_box_checkModel.indexOf(y.id);
                                                if(index != -1) {
                                                    _this.wf_rooms.push({'type': 1, 'room_id': _this.wf_box_checkModel[index]});
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 新增/修改wifi设置
            wifiSub: function(wifiModify) {
                let _this = this;
                let datas,
                    url = '';
                if(wifiModify == 1) {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": $(_this.$refs.wifi_shop).val(), // 门店id
                                "listorder": _this.wifi_listorder, // 序号
                                "name": _this.wifi_name, // wifi名称
                                "password": _this.wifi_psw, // wifi密码
                                "is_all": _this.is_all,
                                "rooms": _this.wf_rooms
                            }
                        },
                        "comment": ""
                    };
                    url = Vue.ctUrl + "Setting/addWifi";
                } else if(wifiModify == 2) {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "id": _this.wf_det.id,
                                "listorder": _this.wifi_listorder, // 序号
                                "name": _this.wifi_name, // wifi名称
                                "password": _this.wifi_psw, // wifi密码
                                "is_all": _this.is_all,
                                "rooms": _this.wf_rooms
                            }
                        },
                        "comment": ""
                    };
                    url = Vue.ctUrl + "Setting/updateWifi";
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: url,
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            $(_this.$refs.wifiList).bootstrapTable('refresh');
                            _this.showWfList = true;
                            _this.showWfSet = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 返回列表
            backListWifi() {
                this.showWfList = true;
                this.showWfSet = false;
                this.showWfBox = false;
            },
            // 删除wifi设置
            delWifi: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delWifi",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            $(_this.$refs.wifiList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },


            /*
             * 触摸屏屏保设置
             */
            // 页面提示语
            openPbHint: function(e) {
                let contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
                layer.tips(contents, (e.currentTarget), {
                    skin: 'hint_language_tip',
                    tips: [2, '#fff'],
                    time: 2000000,
                });
            },
            // 关闭提示语
            closePbHint: function() {
                layer.closeAll('tips');
            },
            // 屏保设置列表
            innitScrnTable: function() {
                let _this = this;
                $(_this.$refs.scrnList).bootstrapTable('destroy');
                $(_this.$refs.scrnList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getScrnList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "listorder",
                        title: "优先级",
                        width: "10%"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "18%"
                    }, {
                        field: "room_name",
                        title: "适用包厢",
                        width: "18%",
                        formatter: function(value, row, index) {
                            return value.split(',').length > 5 ? value.split(',').slice(0, 5).join(',') + '...' : value
                        }
                    }, {
                        field: "count",
                        title: "轮播图片",
                        width: "18%"
                    }, {
                        title: "操作",
                        width: "18%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.scrnModify = 2;
                                _this.getScrnDet(row.id);
                                _this.showScrnList = false;
                                _this.showScrnEdit = true;
                            },
                            'click .delete': function(e, value, row) {
                                layer.confirm('删除后不可恢复，确定删除吗？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.delScrn(row.id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                        }
                    }]
                });
            },
            // 屏保列表数据
            getScrnList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getScreensaverList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击屏保设置
            add_scrn: function() {
                this.scrn_header = '新增屏保';
                // 门店
                $(this.$refs.scrn_shop).val('').trigger('change');
                $(this.$refs.scrn_shop).prop('disabled', false);
                // 包厢号
				// this.getScrnRoom($(this.$refs.scrn_shop).val());
				this.scrn_room_txt = '全部';
                this.scrn_all_rooms = '1';
                this.scrn_room_item = [];
                // 优先级
                this.scrn_listorder = '';

                this.scrn_imgs = [];
                this.hp_num = 0;
                this.scrn_sp_imgs = [];
                this.sp_num = 0;

                this.scrnModify = 1;
                this.showScrnList = false;
                this.showScrnEdit = true;
            },
            // 点击选择包厢号
			scrnRoomFun: function(e) {
                if(this.scrn_all_shops == '1'){
                    this.scrn_room_item = [];
                    layer.msg('门店全选时默认全选包厢');
                    return;
                }
				this.c_scrn_room_item = this.scrn_room_item;
				this.c_scrn_room_all = this.scrn_room_all;
				this.showScrnEdit = false;
				this.showScrnRoom = true;
			},
			// 包厢号数据
			getScrnRoom: function(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoomByArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.scrn_room_arr = data['response']['result'];
							let newarray = [];
							$.each(data['response']['result'], function(k, v) {
								$.each(v.room, function(m, n) {
									newarray.push(n);
								});
							});
							_this.scrn_room_arr_det = newarray;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 全选
			scrnRoomAll: function() {
				let _this = this;
				_this.scrn_room_all = _this.c_scrn_room_all;
				if(!_this.scrn_room_all) { // 实现全选
					_this.scrn_room_item = [];
					_this.scrn_room_arr_det.forEach(function(item) {
						_this.scrn_room_item.push(item.id);
					});
				} else { // 实现反选
					_this.scrn_room_item = [];
				}
			},
			// 楼层全选/反选
			scrnRoomFloor: function(id, index) {
				let _this = this;

				_this.scrn_room_floor = _this.c_scrn_room_floor;
				if(_this.scrn_room_floor.indexOf(id) == -1) {
					$.each(_this.scrn_room_arr[index].room, function(k, v) {
						if(_this.scrn_room_item.indexOf(v.id) == -1) {
							_this.scrn_room_item.push(v.id);
						}
					});
				} else {
					$.each(_this.scrn_room_arr[index].room, function(k, v) {
						let index = '';
						index = _this.scrn_room_item.indexOf(v.id);
						if(index != -1) {
							_this.scrn_room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			scrnRoomSave: function() {
				const _this = this;

				if(_this.scrn_room_all) {
					_this.scrn_room_txt = '全部';
					_this.scrn_all_rooms = '1';
				} else {
					let texts = [];
					_this.scrn_room_arr_det.forEach(function(item) {
						_this.scrn_room_item.forEach(function(sub) {
							if(item.id == sub) {
								texts.push(item.name);
							}
						});
					});
					_this.scrn_room_txt = texts.join(",");
					_this.scrn_all_rooms = '-1';
				}
				_this.showScrnEdit = true;
				_this.showScrnRoom = false;
			},
			// 返回
			scrnRoomBack: function() {
				this.scrn_room_item = this.c_scrn_room_item;
				this.showScrnEdit = true;
				this.showScrnRoom = false;
			},
            // 新增横屏屏保
            addHpimg: function() {
                if(this.hp_num == 10) {
                    layer.msg('屏保轮播图片最多只能设置10张');
                    return;
                }
                this.hp_num++;
                let cls = 'defaultimage' + this.hp_num;
                let ids = 'isflies' + this.hp_num;
                this.scrn_imgs.push({'cls': cls, 'link': require('../../../assets/images/scrn_img_hp.png'), 'ids': ids, status: '-1'});
            },
            // 点击上传图片
            addimageFun: function(num) {
                let _this = this;
                if(num == '0') {
                    $(_this.$refs.isflies1).click();
                } else if(num == '1') {
                    $(_this.$refs.isflies2).click();
                } else if(num == '2') {
                    $(_this.$refs.isflies3).click();
                } else if(num == '3') {
                    $(this.$refs.isflies4).click();
                } else if(num == '4') {
                    $(this.$refs.isflies5).click();
                } else if(num == '5') {
                    $(this.$refs.isflies6).click();
                } else if(num == '6') {
                    $(this.$refs.isflies7).click();
                } else if(num == '7') {
                    $(this.$refs.isflies8).click();
                } else if(num == '8') {
                    $(this.$refs.isflies9).click();
                } else if(num == '9') {
                    $(this.$refs.isflies10).click();
                }
            },
            // 获取序号
            getScrnNum: function(e, index) {
                this.scrnIndex = index;
                this.scrnEvent = e;
            },
            // 上传
            uploadimgFun: function(e, num) {
                var currthis = this;
                var layIndex = layer.load(2, {
                    shade: [0.1, '#ececec']
                });
                var file = e.target.files[0];
                // let file;
                // 清除file
                if(num == '0') {
                    let obj = document.getElementById('isflies1');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '1') {
                    let obj = document.getElementById('isflies2');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '2') {
                    let obj = document.getElementById('isflies3');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '3') {
                    let obj = document.getElementById('isflies4');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '4') {
                    let obj = document.getElementById('isflies5');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '5') {
                    let obj = document.getElementById('isflies6');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '6') {
                    let obj = document.getElementById('isflies7');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '7') {
                    let obj = document.getElementById('isflies8');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '8') {
                    let obj = document.getElementById('isflies9');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '9') {
                    let obj = document.getElementById('isflies10');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                }
                // 压缩图片
                var reader = new FileReader(),
                    img = new Image();
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                if(typeof(file) == 'undefined') {
                    layer.msg('图片上传失败');
                    layer.close(layIndex);
                    return false;
                }
                reader.readAsDataURL(file);
                reader.onload = function(e) {
                    img.src = e.target.result;
                };
                img.onload = function () {
                    // 图片原始尺寸
                    var originWidth = this.width;
                    var originHeight = this.height;
                    // 最大尺寸限制
                    var maxWidth = 1920, maxHeight = 1080;
                    // 目标尺寸
                    var targetWidth = originWidth, targetHeight = originHeight;
                    // 图片尺寸超过限制
                    if(originWidth > maxWidth || originHeight > maxHeight) {
                        if(originWidth / originHeight > maxWidth / maxHeight) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    // canvas对图片进行缩放
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // 清除画布
                    context.clearRect(0, 0, targetWidth, targetHeight);
                    // 图片压缩
                    context.drawImage(img, 0, 0, targetWidth, targetHeight);
                    // canvas转为blob并上传
                    // toDataURL只能压缩jpg格式的图片
                    var dataurl = canvas.toDataURL('image/jpeg', 0.6);
                    var blob = dataURLtoBlob(dataurl);
                    // 创建forme
                    // 转为png格式并上传
                    var form = new FormData();
                    form.append('img', blob, "image.png");
                    form.append("upload_path", "ktv_test");
                    // if(file.size > 1024 * 1024 * 2) {
                    // } else {
                    //     form.append('img', file, "image.jpg");
                    // }
                    // 上传
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        processData: false,
                        contentType: false,
                        url: Vue.ctUrl + "Upload/api_uploadPic",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: form,
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                if(currthis.scrnIndex == '0') {
                                    currthis.scrn_imgs[0].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[0].status = '1';
                                    $('.scrn-hp-list li span').eq(0).show();
                                } else if(currthis.scrnIndex == '1') {
                                    currthis.scrn_imgs[1].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[1].status = '1';
                                    $('.scrn-hp-list li span').eq(1).show();
                                } else if(currthis.scrnIndex == '2') {
                                    currthis.scrn_imgs[2].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[2].status = '1';
                                    $('.scrn-hp-list li span').eq(2).show();
                                } else if(currthis.scrnIndex == '3') {
                                    currthis.scrn_imgs[3].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[3].status = '1';
                                    $('.scrn-hp-list li span').eq(3).show();
                                } else if(currthis.scrnIndex == '4') {
                                    currthis.scrn_imgs[4].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[4].status = '1';
                                    $('.scrn-hp-list li span').eq(4).show();
                                } else if(currthis.scrnIndex == '5') {
                                    currthis.scrn_imgs[5].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[5].status = '1';
                                    $('.scrn-hp-list li span').eq(5).show();
                                } else if(currthis.scrnIndex == '6') {
                                    currthis.scrn_imgs[6].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[6].status = '1';
                                    $('.scrn-hp-list li span').eq(6).show();
                                } else if(currthis.scrnIndex == '7') {
                                    currthis.scrn_imgs[7].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[7].status = '1';
                                    $('.scrn-hp-list li span').eq(7).show();
                                } else if(currthis.scrnIndex == '8') {
                                    currthis.scrn_imgs[8].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[8].status = '1';
                                    $('.scrn-hp-list li span').eq(8).show();
                                } else if(currthis.scrnIndex == '9') {
                                    currthis.scrn_imgs[9].link = data.response.resault.img_url;
                                    currthis.scrn_imgs[9].status = '1';
                                    $('.scrn-hp-list li span').eq(9).show();
                                }
                            } else {
                                Vue.timeoutfun(data.response.result_status, currthis);
                                layer.msg(data.response.error_msg);
                            }
                            layer.close(layIndex);
                        },
                        error: function(err) {
                            layer.msg("网络原因");
                            layer.close(layIndex);
                        }
                    });
                }
            },
            // 上传成功
            successLoadImg: function(event, num) {
                if(event.target.complete == true) {
                    if(num == '0') {
                        $('.defaultimage1').attr('suc', '1');
                    } else if(num == '1') {
                        $('.defaultimage2').attr('suc', '1');
                    } else if(num == '2') {
                        $('.defaultimage3').attr('suc', '1');
                    } else if(num == '3') {
                        $('.defaultimage4').attr('suc', '1');
                    }
                    var imgParentNode = event.target.parentNode;
                    if(imgParentNode.classList.contains('show-img') == true) {
                        imgParentNode.style.background = "#000";
                    }
                }
            },
            // 上传失败
            errorLoadImg: function(event, num) {
                if(num == '0') {
                    $('.defaultimage1').removeAttr('suc');
                } else if(num == '1') {
                    $('.defaultimage2').removeAttr('suc');
                } else if(num == '2') {
                    $('.defaultimage3').removeAttr('suc');
                } else if(num == '3') {
                    $('.defaultimage4').removeAttr('suc');
                }
            },
            // 查看大图
            bigHp: function(hsrc) {
                let _this = this;
                _this.big_hp_url = hsrc;
                layer.confirm('', {
                    skin: 'store-big',
                    type: 1,
                    btn: ['查看大图'],
                    title: ['查看大图', true],
                    area: ['1067px', '630px'], //宽高
                    content: $(_this.$refs.big_hp),
                    offset: '100px'
                });
            },
            // 删除图片
            delScrnHp: function(num) {
                this.hp_num--;
                this.scrn_imgs.splice(num, 1);
            },
            // 新增竖屏屏保
            addSpimg: function() {
                if(this.sp_num == 10) {
                    layer.msg('屏保轮播图片最多只能设置10张');
                    return;
                }
                this.sp_num++;
                let cls = 'detimgSp' + this.sp_num;
                let ids = 'spFlies' + this.sp_num;
                this.scrn_sp_imgs.push({'cls': cls, 'link': require('../../../assets/images/scrn_img_sp.png'), 'ids': ids, status: '-1'});
            },
            // 点击上传竖屏图片
            addimgSpFun: function(num) {
                let _this = this;
                if(num == '0') {
                    $(_this.$refs.spFlies1).click();
                } else if(num == '1') {
                    $(_this.$refs.spFlies2).click();
                } else if(num == '2') {
                    $(_this.$refs.spFlies3).click();
                } else if(num == '3') {
                    $(this.$refs.spFlies4).click();
                } else if(num == '4') {
                    $(this.$refs.spFlies5).click();
                } else if(num == '5') {
                    $(this.$refs.spFlies6).click();
                } else if(num == '6') {
                    $(this.$refs.spFlies7).click();
                } else if(num == '7') {
                    $(this.$refs.spFlies8).click();
                } else if(num == '8') {
                    $(this.$refs.spFlies9).click();
                } else if(num == '9') {
                    $(this.$refs.spFlies10).click();
                }
            },
            // 上传竖屏
            uploadSpimgFun: function(e, num) {
                var currthis = this;
                var layIndex = layer.load(2, {
                    shade: [0.1, '#ececec']
                });
                var file = e.target.files[0];
                // 清除file
                if(num == '0') {
                    let obj = document.getElementById('spFlies1');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '1') {
                    let obj = document.getElementById('spFlies2');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '2') {
                    let obj = document.getElementById('spFlies3');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '3') {
                    let obj = document.getElementById('spFlies4');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '4') {
                    let obj = document.getElementById('spFlies5');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '5') {
                    let obj = document.getElementById('spFlies6');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '6') {
                    let obj = document.getElementById('spFlies7');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '7') {
                    let obj = document.getElementById('spFlies8');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '8') {
                    let obj = document.getElementById('spFlies9');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                } else if(num == '9') {
                    let obj = document.getElementById('spFlies10');
                    obj.value = '';
                    obj.outerHTML = obj.outerHTML;
                }
                // 压缩图片
                var reader = new FileReader(),
                    img = new Image();
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                if(typeof(file) == 'undefined') {
                    layer.msg('图片上传失败');
                    layer.close(layIndex);
                    return false;
                }
                reader.readAsDataURL(file);
                reader.onload = function(e) {
                    img.src = e.target.result;
                };
                img.onload = function () {
                    // 图片原始尺寸
                    var originWidth = this.width;
                    var originHeight = this.height;
                    // 最大尺寸限制
                    var maxWidth = 1080, maxHeight = 1920;
                    // 目标尺寸
                    var targetWidth = originWidth, targetHeight = originHeight;
                    // 图片尺寸超过限制
                    if(originWidth > maxWidth || originHeight > maxHeight) {
                        if(originWidth / originHeight > maxWidth / maxHeight) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    // canvas对图片进行缩放
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // 清除画布
                    context.clearRect(0, 0, targetWidth, targetHeight);
                    // 图片压缩
                    context.drawImage(img, 0, 0, targetWidth, targetHeight);
                    // canvas转为blob并上传
                    // toDataURL只能压缩jpg格式的图片
                    var dataurl = canvas.toDataURL('image/jpeg', 0.6);
                    var blob = dataURLtoBlob(dataurl);
                    // 创建forme
                    // 转为png格式并上传
                    var form = new FormData();
                    form.append('img', blob, "image.png");
                    form.append("upload_path", "ktv_test");
                    // 上传
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        processData: false,
                        contentType: false,
                        url: Vue.ctUrl + "Upload/api_uploadPic",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: form,
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                if(num == '0') {
                                    currthis.scrn_sp_imgs[0].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[0].status = '1';
                                    $('.scrn-sp-list li span').eq(0).show();
                                } else if(num == '1') {
                                    currthis.scrn_sp_imgs[1].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[1].status = '1';
                                    $('.scrn-sp-list li span').eq(1).show();
                                } else if(num == '2') {
                                    currthis.scrn_sp_imgs[2].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[2].status = '1';
                                    $('.scrn-sp-list li span').eq(2).show();
                                } else if(num == '3') {
                                    currthis.scrn_sp_imgs[3].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[3].status = '1';
                                    $('.scrn-sp-list li span').eq(3).show();
                                } else if(num == '4') {
                                    currthis.scrn_sp_imgs[4].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[4].status = '1';
                                    $('.scrn-sp-list li span').eq(4).show();
                                } else if(num == '5') {
                                    currthis.scrn_sp_imgs[5].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[5].status = '1';
                                    $('.scrn-sp-list li span').eq(5).show();
                                } else if(num == '6') {
                                    currthis.scrn_sp_imgs[6].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[6].status = '1';
                                    $('.scrn-sp-list li span').eq(6).show();
                                } else if(num == '7') {
                                    currthis.scrn_sp_imgs[7].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[7].status = '1';
                                    $('.scrn-sp-list li span').eq(7).show();
                                } else if(num == '8') {
                                    currthis.scrn_sp_imgs[8].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[8].status = '1';
                                    $('.scrn-sp-list li span').eq(8).show();
                                } else if(num == '9') {
                                    currthis.scrn_sp_imgs[9].link = data.response.resault.img_url;
                                    currthis.scrn_sp_imgs[9].status = '1';
                                    $('.scrn-sp-list li span').eq(9).show();
                                }
                            } else {
                                Vue.timeoutfun(data.response.result_status, currthis);
                                layer.msg(data.response.error_msg);
                            }
                            layer.close(layIndex);
                        },
                        error: function(err) {
                            layer.msg("网络原因");
                            layer.close(layIndex);
                        }
                    });
                }
            },
            // 查看大图
            bigSp: function(ssrc) {
                let _this = this;
                _this.big_sp_url = ssrc;
                layer.confirm('', {
                    skin: 'store-big',
                    type: 1,
                    btn: ['查看大图'],
                    title: ['查看大图', true],
                    area: ['350px', '623px'], // 宽高
                    content: $(_this.$refs.big_sp),
                    offset: '100px'
                });
            },
            // 删除图片
            delScrnSp: function(num) {
                this.sp_num--;
                this.scrn_sp_imgs.splice(num, 1);
            },
            // 屏保详情
            getScrnDet: function(id) {
                let _this = this;
                _this.scrn_header = '修改屏保';

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getScreensaverDetail",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.scrn_det = data.response.result;
                            $(_this.$refs.scrn_shop).val(_this.scrn_det.shop_id).trigger('change');
                            $(_this.$refs.scrn_shop).prop('disabled', true);
                            // 包厢号
                            if(_this.scrn_det.all_shops == '1'){
                                console.log('是全部门店');
                                _this.scrn_room_txt = '全部';
                                _this.scrn_all_rooms = '1';
                                _this.scrn_room_item = [];
                                _this.scrn_all_shops = '1';
                            }else{
                                _this.scrn_all_shops = '-1';
                                _this.getScrnRoom(_this.scrn_det.shop_id);
                                _this.scrn_all_rooms = _this.scrn_det.all_rooms;
                                _this.scrn_room_txt = _this.scrn_det.room_name;
                            }
                            if(_this.scrn_all_rooms == '1') {
                                _this.scrn_room_item = [];
                                _this.scrn_room_arr_det.forEach(function(item) {
                                    _this.scrn_room_item.push(item.id);
                                });
                            } else {
                                _this.scrn_room_item = _this.scrn_det.room_id.split(',');
                            }
                            // 优先级
                            _this.scrn_listorder = _this.scrn_det.listorder;
                            // 横屏
                            _this.scrn_imgs = [];
                            $.each(_this.scrn_det.horizon_imgs, function(k, v) {
                                let cls = 'defaultimage' + (parseInt(k) + 1);
                                let ids = 'isflies' + (parseInt(k) + 1);
                                // _this.scrn_imgs[k].link = v;
                                _this.scrn_imgs.push({'cls': cls, 'link': v, 'ids': ids, status: '-1'});
                            });
                            _this.hp_num = _this.scrn_det.horizon_imgs.length;

                            // 竖屏
                            _this.scrn_sp_imgs = [];
                            $.each(_this.scrn_det.vertical_imgs, function(k, v) {
                                let cls = 'detimgSp' + (parseInt(k) + 1);
                                let ids = 'spFlies' + (parseInt(k) + 1);
                                _this.scrn_sp_imgs.push({'cls': cls, 'link': v, 'ids': ids, status: '-1'});
                            });
                            _this.sp_num = _this.scrn_det.vertical_imgs.length;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 新增、修改屏保
            scrnSub: function() {
                let _this = this;
                let horizon_imgs = [],
                    vertical_imgs = [];
                $.each(_this.scrn_imgs, function(k, v) {
                    horizon_imgs.push(v.link);
                });
                $.each(_this.scrn_sp_imgs, function(k, v) {
                    vertical_imgs.push(v.link);
                });

                let datas,
                    url = '';
                if(_this.scrnModify == '1') {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": $(_this.$refs.scrn_shop).val(), // 门店id
                                "all_rooms": _this.scrn_all_rooms,
                                "room_id": _this.scrn_room_item.join(','),
                                "listorder": _this.scrn_listorder,
                                "horizon_imgs": horizon_imgs, // 横屏图片地址
                                "vertical_imgs": vertical_imgs, // 竖屏图片地址
                                "all_shops": _this.scrn_all_shops
                            }
                        },
                        "comment": ""
                    };
                    url = Vue.ctUrl + "Setting/addScreensaver";
                } else if(_this.scrnModify == '2') {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": _this.scrn_det.id,
                                "all_rooms": _this.scrn_all_rooms,
                                "room_id": _this.scrn_room_item.join(','),
                                "listorder": _this.scrn_listorder,
                                "horizon_imgs": horizon_imgs, // 横屏图片地址
                                "vertical_imgs": vertical_imgs, // 竖屏图片地址
                                "all_shops": _this.scrn_all_shops
                            }
                        },
                        "comment": ""
                    };
                    url = Vue.ctUrl + "Setting/updateScreensaver";
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            _this.innitScrnTable();
                            _this.showScrnList = true;
                            _this.showScrnEdit = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回列表
            backListScrn() {
                this.showScrnList = true;
                this.showScrnEdit = false;
            },
            // 删除屏保
            delScrn: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delScreensaver",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            _this.innitScrnTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 触摸屏呼叫服务设置
             */
            // 初始化呼叫服务设置列表
            innitChfTable: function() {
                let _this = this;
                $(_this.$refs.chfList).bootstrapTable('destroy');
                $(_this.$refs.chfList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getChfList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "call_server_status",
                        title: "呼叫服务设置",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.chfConfigSub(row.shop_id, 'call_server_status', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.call_server_status == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>开启</option><option value='-1'>关闭</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>开启</option><option value='-1' selected>关闭</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "call_server",
                        title: "服务名称",
                        width: "25%",
                        formatter: function(value, row, index) {
                            if(row.call_server.length == '0') {
                                return '无';
                            } else {
                                return row.call_server.join(',');
                            }
                        }
                    }, {
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.chf_shop_id = row.shop_id;
                                _this.chf_shop_name = row.shop_name;
                                // 服务名称
                                _this.chf_name = '';
                                _this.chf_name_lists = [];
                                $.each(row.call_server, function(k, v) {
                                    if(k == 0) {
                                        _this.chf_name = v;
                                    } else {
                                        _this.chf_name_lists.push({'name_model': v});
                                    }
                                });
                                $('.chf-list').hide();
                                $('.chf-modify').show();
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // 呼叫服务设置列表
            getChfList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getCallServerSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 新增服务名称
            addChfName: function() {
                if(this.chf_name_lists.length > 8) {
                    layer.msg('服务名称最多只能设置10条');
                    return;
                }
                this.chf_name_lists.push({'name_model': ''});
            },
            // 删除服务名称
            delChfName: function(index) {
                this.chf_name_lists.splice(index, 1);
            },
            // 点击添加参考名称
            addChfPre: function(name) {
                let _this = this;
                if($.trim(_this.chf_name) == '') {
                    _this.chf_name = name;
                } else if(_this.chf_name_lists.length == '0') {
                    _this.chf_name_lists.push({'name_model': name});
                } else {
                    $.each(_this.chf_name_lists, function(k, v) {
                        if($.trim(v.name_model) == '') {
                            _this.chf_name_lists[k].name_model = name;
                            return false;
                        } else if(k < _this.chf_name_lists.length - 1) {
                            return;
                        } else {
                            if(_this.chf_name_lists.length > 8) {
                                layer.msg('服务名称最多只能设置10条');
                            } else {
                                _this.chf_name_lists.push({'name_model': name});
                            }
                        }
                    });
                }
            },
            // 返回
            backChfList: function() {
                $('.chf-list').show();
                $('.chf-modify').hide();
            },
            // 修改
            chfSub: function() {
                let _this = this,
                    call_server = [];
                if($.trim(_this.chf_name) != '') {
                    call_server.push(_this.chf_name);
                }
                $.each(_this.chf_name_lists, function(k, v) {
                    if($.trim(v.name_model) != '') {
                        call_server.push(v.name_model);
                    }
                });
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.chf_shop_id,
                            "call_server": call_server
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setCallServerSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.chfList).bootstrapTable('refresh');
                            $('.chf-list').show();
                            $('.chf-modify').hide();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 呼叫服务设置
            chfConfigSub: function(shop_id, key, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": shop_id,
                            "config_type": key,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('修改成功');
                            $(_this.$refs.chfList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * disco限制播放时间设置
             */
            // 初始化disco限制播放时间设置列表
            innitDiscoTable: function() {
                let _this = this;
                $(_this.$refs.discoList).bootstrapTable('destroy');
                $(_this.$refs.discoList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getDiscoList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "适用门店",
                        width: "33%"
                    }, {
                        field: "start_time_str",
                        title: "开启时间",
                        width: "33%"
                    }, {
                        title: "操作",
                        width: "33%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.getDiscoTime();
                                _this.openDiscoModify(row);
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // disco限制播放时间设置列表
            getDiscoList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getDiscoSettingList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取时间
            getDiscoTime: function() {
                let _this = this;
                let seconds = [];
                for(let i = 0; i < 60; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    seconds[i] = item;
                };
                let hour = [];
                for(let i = 0; i < 24; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    hour[i] = item;
                }
                $(_this.$refs.discoHour).select2({
                    data: hour,
                    language: "zh-CN",
                    width: '150px'
                });
                $(_this.$refs.discoSeconds).select2({
                    data: seconds,
                    language: "zh-CN",
                    width: '150px'
                });
            },
            // disco限制播放时间设置弹窗、修改
            openDiscoModify: function(row) {
                let _this = this;
                // 初始值
                if(row.start_time_str == '无') {
                    _this.disco_time = true;
                    $(_this.$refs.discoHour).val('').trigger('change');
                    $(_this.$refs.discoSeconds).val('').trigger('change');
                } else {
                    _this.disco_time = false;
                    $(_this.$refs.discoHour).val(row.start_time_str.split(':')[0]).trigger('change');
                    $(_this.$refs.discoSeconds).val(row.start_time_str.split(':')[1]).trigger('change');
                }
                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['开启时间', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.discoAlert)
                }, function() {
                    // 获取选择的时间
                    let start_time;
                    if(_this.disco_time) {
                        start_time = '-1';
                    } else {
                        start_time = $(_this.$refs.discoHour).val() + ':' + $(_this.$refs.discoSeconds).val()
                    }
                    // 修改
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": row.shop_id,
                                "start_time": start_time
                            }
                        },
                        "comment": ""
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/updateDiscoSetting",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.msg(data.response.error_msg);
                                $(_this.$refs.discoList).bootstrapTable("refresh");
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                            layer.closeAll();
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },


            /*
             * 网关检测设置
             */
            // 初始化网关检测
            innitWgTable: function() {
                let _this = this;
                $(_this.$refs.wgList).bootstrapTable('destroy');
                $(_this.$refs.wgList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getWgList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "gateway",
                        title: "ip地址",
                        width: "30%"
                    }, {
                        title: "操作",
                        width: "30%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.wg_shop = row.name;
                                _this.wg_ip = row.gateway;
                                _this.wgEdit(row.id);
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // 网关检测设置列表
            getWgList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getGatewayList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 修改网关检测
            wgEdit: function(shop_id) {
                let _this = this;

                layer.confirm('', {
                    skin: 'add_goods-alert',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: ['网关检测设置', true],
                    area: ['560px', ''],
                    content: $(_this.$refs.wg_edit),
                    offset: '100px'
                }, function() {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id,
                                "config": _this.wg_ip
                            }
                        },
                        "comment": ""
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "Shop/setGateway",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: datas2,
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.closeAll();
                                // _this.initTable();
                                $(_this.$refs.wgList).bootstrapTable('refresh');
                                layer.msg('操作成功');
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },


            /*
             * 触摸屏下单人员是否默认导购员设置
             */
            // 初始化是否默认导购员设置
            innitCmdTable: function() {
                let _this = this;
                $(_this.$refs.cmdList).bootstrapTable('destroy');
                $(_this.$refs.cmdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getCmdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "序号",
                        width: "10%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "screen_shopping_guide_set",
                        title: "触摸屏下单人员是否默认导购员",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.cmdSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.screen_shopping_guide_set == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>下单操作人</option><option value='2'>订台人</option><option value='-1'>无</option></select>";
                            } else if(row.screen_shopping_guide_set == "2") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>下单操作人</option><option value='2' selected>订台人</option><option value='-1'>无</option></select>";
                            } else if(row.screen_shopping_guide_set == "-1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>下单操作人</option><option value='2'>订台人</option><option value='-1' selected>无</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 是否默认导购员设置列表
            getCmdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "screen_shopping_guide_set"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 是否默认导购员设置
            cmdSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "screen_shopping_guide_set"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs.cmdList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 触摸屏下单推荐设置
             */
            // 获取商品套餐类型
            getGoodsPackageType() {
                const _this = this;

                Vue.axios.post('PublicData/api_getWaresType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        res.data.response.result.data.forEach(v => {
                            _this.goods_type_list.push({
                                id: '-2' + v.id,
                                name: v.name,
                                type: 'package',
                                type_id: v.id
                            });
                        });
                        _this.getGoodsType();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        res.data.response.result.data.forEach(v => {
                            _this.goods_type_list.push({
                                id: v.id,
                                name: v.name
                            });
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 更改商品（套餐）类型
            popGoodsType(val) {
                this.pop_goods_type_sign = val.type
                if(this.pop_goods_type_sign == 'package') {
                    this.pop_goods_type_id = val.type_id
                    this.pop_goods_type_name = val.name
                } else {
                    this.pop_goods_type_id = val.id
                    this.pop_goods_type_name = val.name
                }
                this.popGoodsTable(1)
            },
            // 获取商品（套餐）
            popGoodsTable: function(page) {
                const _this = this

                _this.loading = true
                _this.pop_goods_page = page
                let url = "merchantGoods/searchMerchantGoodsList"
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZEMINI,
                            "shop_id": _this.dtj_edit_form.shop_id,
                            "goods_type": _this.pop_goods_type_id,
                            "goods_name": _this.pop_goods_name,
                            "status": '1'
                        }
                    },
                    "comment": ""
                };
                if(_this.pop_goods_type_sign == 'package') {
                    url = "merchantGoods/searchMerchantGoodsPackage";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.pop_goods_total = Number(res.data.response.result.data.total);
                        }
                        if(_this.pop_goods_type_sign == 'package') {
                            _this.pop_goods_columns = [{
                                "prop": 'name',
                                "label": '名称'
                            }, {
                                "prop": 'package_unit_name',
                                "label": '单位'
                            }]
                        } else {
                            _this.pop_goods_columns = [{
                                "prop": 'goods_name',
                                "label": '名称'
                            }, {
                                "prop": 'goods_unit_name',
                                "label": '单位'
                            }]
                        }
                        _this.pop_goods_table = res.data.response.result.data.rows
                        _this.loading = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 单选
            popTableRow(row) {
                this.pop_table_select = row
            },
            // 添加商品（套餐）
            dtjGoodsSelect(index) {
                const _this = this;

                _this.csg_type = ''
                _this.pop_goods_name = ''
                _this.pop_goods_page = 1
                _this.pop_table_radio = ''
                _this.popGoodsTable(1)
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择关联商品', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.pop_goods_wrap)
                }, function() {
                    // 保存
                    if(_this.pop_goods_type_sign == 'package') {
                        _this.dtj_edit_form.goods[index].type = 2
                        _this.dtj_edit_form.goods[index].goods_id = _this.pop_table_select.id
                        _this.dtj_edit_form.goods[index].goods_name = _this.pop_table_select.name
                    } else {
                        _this.dtj_edit_form.goods[index].type = 1
                        _this.dtj_edit_form.goods[index].goods_id = _this.pop_table_select.id
                        _this.dtj_edit_form.goods[index].goods_name = _this.pop_table_select.goods_name
                    }
                    layer.closeAll()
                });
            },
            // 删除
            dtjGoodsDel(index) {
                this.dtj_edit_form.goods[index].type = ''
                this.dtj_edit_form.goods[index].goods_id = ''
                this.dtj_edit_form.goods[index].goods_name = ''
            },

            // 获取门店列表
            getShop: function(num) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        if (num == '8') { // 触摸屏点单推荐设置
                            _this.dtj_list_form.shop_id = _this.shop_list[0].id
                            _this.dtjTable(1)
                            _this.initDate('dtj')
                            _this.dtjImgUploadInit()
                            _this.getGoodsPackageType()
                        }else if(num == '9') { // 触摸屏点单热搜词设置
                            _this.drc_list_form.shop_id = _this.shop_list[0].id
                            _this.drcTable(1)
                            _this.initDate('drc')
                        }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 日期
            initDate: function(name) {
                const _this = this;

                if(name === 'dtj') {
                    $(_this.$refs.dtj_usedate_main).daterangepicker({
                        parentEl: '.dtj-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
                        event.preventDefault()
                        _this.dtj_usedate_start = start.format('YYYY-MM-DD');
                        _this.dtj_usedate_end = end.format('YYYY-MM-DD');
                        if($(".dtj-usedate-everyday input").val() == "1") {
                            _this.dtj_usedate_txt = '每天';
                            _this.dtj_use_every_day = 1;
                            return;
                        } else {
                            _this.dtj_usedate_txt = _this.dtj_usedate_start + ' ~ ' + _this.dtj_usedate_end;
                            _this.dtj_use_every_day = -1;
                        }
                    });
                    $(".dtj-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="dtj-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".dtj-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                } else if(name === 'drc') {
                    $(_this.$refs.drc_usedate_main).daterangepicker({
                        parentEl: '.drc-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
                        event.preventDefault()
                        _this.drc_usedate_start = start.format('YYYY-MM-DD');
                        _this.drc_usedate_end = end.format('YYYY-MM-DD');
                        if($(".drc-usedate-everyday input").val() == "1") {
                            _this.drc_usedate_txt = '每天';
                            _this.drc_use_every_day = 1;
                            return;
                        } else {
                            _this.drc_usedate_txt = _this.drc_usedate_start + ' ~ ' + _this.drc_usedate_end;
                            _this.drc_use_every_day = -1;
                        }
                    });
                    $(".drc-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="drc-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".drc-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                }
            },
            
            // 列表
            dtjTable: function(page) {
                const _this = this;

                _this.loading = true;
                _this.dtj_page = page
                Vue.axios.post('ScreenSkin/getRecommendGoodsList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.dtj_list_form.shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.dtj_total = Number(res.data.response.result.total);
                        }
                        _this.dtj_table = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
             
            // 禁用启用
            dtjStatus(row) {
                const _this = this;

                layer.confirm('确定'+ (row.status == '1' ? '禁用' : '启用') +'吗？', {
                    btn: ['确定', '取消']
                }, function() {
                    Vue.axios.post('ScreenSkin/updateRecommendGoodsStatus', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": row.id,
                                "status": -row.status
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.dtjTable(_this.dtj_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },
            // 删除
            dtjDel(id) {
                const _this = this;

                layer.confirm('删除后不可恢复，确定删除吗？', {
                    btn: ['确定', '取消']
                }, function() {
                    Vue.axios.post('ScreenSkin/delRecommendGoodsData', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.dtjTable(_this.dtj_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },
            // 点击新增
            dtjAdd() {
                const _this = this
                _this.dtj_edit_id = ''
                _this.dtj_edit_tit = '新增推荐'
                _this.dtj_edit_form = {
                    shop_id: _this.shop_list[0].id,
                    listorder: '',
                    goods: [{
                        img: require('../../../assets/images/upload_btn.png'),
                        img_id: 'dtjImg0',
                        img_done: false,
                        type: '',
                        goods_id: '',
                        goods_name: ''
                    }]
                }
                new Promise(resolve => {
                    _this.dtjRoomList(_this.dtj_edit_form.shop_id, resolve)
                })
                .then(res => {
                    _this.dtj_use_all_room = -1
                    _this.dtj_room_txt = ''
                    _this.dtj_room_item = []
                })
                _this.dtj_usedate_txt = ''
                _this.dtj_use_every_day = -1
                $(".dtj-usedate-everyday input").val("");
                $(".dtj-usedate-everyday input").prop("checked", false);
                _this.dtj_usedate_start = ''
                _this.dtj_usedate_end = ''
                _this.dtj_usetime_txt = ''
                _this.dtj_usetime_start = ''
                _this.dtj_usetime_end = ''
                _this.dtj_week_txt = ''
                _this.dtj_week_ids = []
                _this.dtj_week_sign = false
                _this.dtj_week_all = false
                _this.dtjImgUpload('dtjImg0', 0)
                _this.showDtjList = false
                _this.showDtjEdit = true
            },
            // 点击修改
            dtjModify(id) {
                const _this = this

                Vue.axios.post('ScreenSkin/getRecommendGoodsData', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result

                        _this.dtj_edit_id = row.id
                        _this.dtj_edit_tit = '修改推荐'
                        _this.dtj_edit_form = {
                            shop_id: row.shop_id,
                            listorder: row.listorder,
                            goods: []
                        }
                        new Promise(resolve => {
                            _this.dtjRoomList(_this.dtj_edit_form.shop_id, resolve)
                        }).then(res => {
                            _this.dtj_use_all_room = row.all_room
                            _this.dtj_room_txt = row.room_names
                            _this.dtj_room_item = row.room_ids.split(',')
                        })
                        _this.dtj_use_every_day = row.use_every_day
                        _this.dtj_usedate_start = row.start_date
                        _this.dtj_usedate_end = row.end_date
                        if(row.use_every_day == 1) {
                            $(".dtj-usedate-everyday input").val("1");
                            $(".dtj-usedate-everyday input").prop("checked", true);
                            _this.dtj_usedate_txt = '每天'
                        } else {
                            $(".dtj-usedate-everyday input").val("");
                            $(".dtj-usedate-everyday input").prop("checked", false);
                            _this.dtj_usedate_txt = row.start_date + '~' + row.end_date
                        }
                        _this.dtj_usetime_txt = row.start_time + '~' + row.end_time
                        _this.dtj_usetime_start = row.start_time
                        _this.dtj_usetime_end = row.end_time
                        _this.dtj_week_ids = row.week_cycle
                        _this.dtj_week_sign = _this.dtj_week_ids.length > 0 && _this.dtj_week_ids.length < _this.week_list.length;
                        _this.dtj_week_all = _this.dtj_week_ids.length === _this.week_list.length;
                        let week_txt = [];
                        _this.week_list.forEach(_ => {
                            _this.dtj_week_ids.forEach(item => {
                                if(_.id == item) {
                                    week_txt.push(_.name);
                                }
                            });
                        });
                        _this.dtj_week_txt = week_txt.join(',');
                        if(row.goods.length == 0) {
                            this.dtj_edit_form.goods = [{
                                img: require('../../../assets/images/upload_btn.png'),
                                img_id: 'dtjImg0',
                                img_done: false,
                                type: '',
                                goods_id: '',
                                goods_name: ''
                            }]
                        } else {
                            row.goods.forEach((item, index) => {
                                this.dtj_edit_form.goods.push({
                                    img: item.img,
                                    img_id: 'dtjImg' + index,
                                    img_done: true,
                                    type: item.type,
                                    goods_id: item.goods_id,
                                    goods_name: item.goods_name,
                                })
                                this.dtjImgUpload('dtjImg' + index, index)
                            })
                        }
                        _this.showDtjList = false
                        _this.showDtjEdit = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            dtjShopChange(val) {
                new Promise(resolve => {
                    this.dtjRoomList(val, resolve)
                })
                this.dtj_use_all_room = -1
                this.dtj_room_txt = ''
                this.dtj_room_item = []
            },
            // 获取包厢号
            dtjRoomList: function(shop_id, resolve) {
                const _this = this;

                Vue.axios.post('Shop/getAllRoomByArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.dtj_room_arr = res.data.response.result;
                        _this.dtj_room_arr_det = [];
                        res.data.response.result.forEach(_ => {
                            _.room.forEach(item => _this.dtj_room_arr_det.push(item))
                        });
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 点击选择包厢号
            dtjRoomSelect: function(e) {
                this.dtj_c_room_item = [...this.dtj_room_item]
                this.showDtjEdit = false
                this.showDtjRoom = true
            },
            dtjRoomDel() {
                this.dtj_use_all_room = -1
                this.dtj_room_txt = ''
                this.dtj_room_item = []
            },
            // 全选
            dtjRoomAll: function() {
                const _this = this;

                if(!_this.dtj_room_all) { // 实现全选
                    _this.dtj_room_item = [];
                    _this.dtj_room_arr_det.forEach(item => {
                        _this.dtj_room_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.dtj_room_item = [];
                }
            },
            // 楼层全选/反选
            dtjRoomFloor: function(id, index) {
                const _this = this;

                if(_this.dtj_room_floor.indexOf(id) == -1) {
                    _this.dtj_room_arr[index].room.forEach(item => {
                        if(_this.dtj_room_item.indexOf(item.id) == -1) {
                            _this.dtj_room_item.push(item.id);
                        }
                    });
                } else {
                    _this.dtj_room_arr[index].room.forEach(item => {
                        let index = '';
                        index = _this.dtj_room_item.indexOf(item.id);
                        if(index != -1) {
                            _this.dtj_room_item.splice(index, 1);
                        }
                    });
                }
            },
            // 确定包厢
            dtjRoomSave: function() {
                const _this = this;

                if(_this.dtj_room_all) {
                    _this.dtj_room_txt = '全部'
                    _this.dtj_use_all_room = 1
                } else {
                    let texts = [];
                    _this.dtj_room_arr_det.forEach(_ => {
                        _this.dtj_room_item.forEach(item => {
                            if(_.id == item) {
                                texts.push(_.name);
                            }
                        });
                    });
                    _this.dtj_room_txt = texts.join(",");
                    _this.dtj_use_all_room = -1;
                }
                _this.showDtjEdit = true
                _this.showDtjRoom = false
            },
            // 返回
            dtjRoomBack: function() {
                this.dtj_room_item = [...this.dtj_c_room_item]
                this.showDtjEdit = true
                this.showDtjRoom = false
            },
            dtjUsetime: function() {
                const _this = this;

                _this.dtj_hour_start = _this.dtj_usetime_start.split(':')[0] || '00'
                _this.dtj_minute_start = _this.dtj_usetime_start.split(':')[1] || '00'
                _this.dtj_hour_end = _this.dtj_usetime_end.split(':')[0] || '00'
                _this.dtj_minute_end = _this.dtj_usetime_end.split(':')[1] || '00'
                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin',
                    btn: ['确定', '取消'], // 按钮
                    title: '使用时间',
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.dtj_usetime_alert)
                }, function() {
                    _this.dtj_usetime_start = _this.dtj_hour_start + ":" + _this.dtj_minute_start
                    _this.dtj_usetime_end = _this.dtj_hour_end + ":" + _this.dtj_minute_end
                    _this.dtj_usetime_txt = _this.dtj_usetime_start + " ~ " + _this.dtj_usetime_end
                    layer.closeAll();
                });
            },
            // 星期
            dtjWeekSelect() {
                const _this = this;
                const c_week_ids = _this.dtj_week_ids,
                    c_week_sign = _this.dtj_week_sign,
                    c_week_all = _this.dtj_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dtj_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dtj_week_ids = c_week_ids;
                        _this.dtj_week_sign = c_week_sign;
                        _this.dtj_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.dtj_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dtj_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dtj_week_ids = c_week_ids;
                    _this.dtj_week_sign = c_week_sign;
                    _this.dtj_week_all = c_week_all;
                });
            },
            dtjWeekDel() {
                this.dtj_week_sign = false;
                this.dtj_week_all = false;
                this.dtj_week_ids = [];
            },
            dtjWeekAll(val) {
                let ids = [];
                this.week_list.forEach(v => {
                    ids.push(v.id);
                });
                this.dtj_week_ids = val ? ids : [];
                this.dtj_week_sign = false;
            },
            dtjWeekChange(val) {
                const len = val.length;
                this.dtj_week_sign = len > 0 && len < this.week_list.length;
                this.dtj_week_all = len === this.week_list.length;
            },
            // 新增商品
            dtjImgAdd: function() {
                const index = this.dtj_edit_form.goods.length
                this.dtj_edit_form.goods.push({
                    img: require('../../../assets/images/upload_btn.png'),
                    img_id: 'dtjImg' + index,
                    img_done: false,
                    type: '',
                    goods_id: '',
                    goods_name: ''
                })
                this.dtjImgUpload('dtjImg' + index, index)
            },
            // 删除商品
            dtjImgDel: function(num) {
                this.dtj_edit_form.goods.splice(num, 1)
                this.dtj_edit_form.goods.forEach((item, index) => {
                    this.dtj_edit_form.goods[index].img_id = 'dtjImg' + index
                })
            },
            // 上传人物图片
            dtjImgUploadInit: function() {
                let _this = this;
                let host = '',
                    dir = '',
                    file_name = '';

                setTimeout(function() {
                    // 实例化一个plupload上传对象
                    let uploader = new plupload.Uploader({
                        browse_button: 'dtjImg0', // 选择文件id
                        filters: {
                            mime_types: [ // 文件格式限制
                                { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                            ],
                            max_file_size: '5mb', // 文件大小限制
                            // prevent_duplicates: true // 不允许选取重复文件
                        },
                        resize: {
                            width: 960,
                            height: 300
                        },
                        multi_selection: false, // 单选
                        url: './', // OSS地址
                        init: {
                            // 文件上传前触发
                            BeforeUpload: function(up, file) {},
                            // 文件选择完毕触发
                            FilesAdded: function(up, files) {
                                // 获取签名
                                Vue.axios.post('publicData/api_getOssSignature', {
                                    "header": Vue.request_header,
                                    "request": {
                                        "version": Vue.version,
                                        "param": {
                                            "file": files[0].name,
                                            "path": 'system_set'
                                        }
                                    },
                                    "comment": ""
                                })
                                .then(res => {
                                    if(res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                            },
                            // 文件上传成功触发
                            FileUploaded: function(up, file, data) {
                                _this.dtj_edit_form.goods[0].img = host + "/" + dir + file_name;
                                _this.dtj_edit_form.goods[0].img_done = true;
                                layer.msg('上传成功');
                            },
                            // 错误提示
                            Error: function(up, err) {
                                if(err.code == -600) {
                                    layer.msg('请选择2mb以内的文件');
                                } else if (err.code == -601) {
                                    layer.msg('只允许上传jpg,jpeg,png,gif文件');
                                } else if (err.code == -602) {
                                    layer.msg('这个文件已经上传过一遍了');
                                } else {
                                    layer.msg(err.response);
                                }
                            }
                        }
                    });
                    // 初始化
                    uploader.init();
                }, 20);
            },
            dtjImgUpload: function(id, index) {
                if(index === 0) {
                    return false;
                }
                let _this = this;
                let host = '',
                    dir = '',
                    file_name = '';

                setTimeout(function() {
                    // 实例化一个plupload上传对象
                    let uploader = new plupload.Uploader({
                        browse_button: id, // 选择文件id
                        filters: {
                            mime_types: [ // 文件格式限制
                                { title: "Image files", extensions: "jpg,jpeg,png,gif" }
                            ],
                            max_file_size: '5mb', // 文件大小限制
                            // prevent_duplicates: true // 不允许选取重复文件
                        },
                        resize: {
                            width: 960,
                            height: 300
                        },
                        multi_selection: false, // 单选
                        url: './', // OSS地址
                        init: {
                            // 文件上传前触发
                            BeforeUpload: function(up, file) {},
                            // 文件选择完毕触发
                            FilesAdded: function(up, files) {
                                // 获取签名
                                Vue.axios.post('publicData/api_getOssSignature', {
                                    "header": Vue.request_header,
                                    "request": {
                                        "version": Vue.version,
                                        "param": {
                                            "file": files[0].name,
                                            "path": 'system_set'
                                        }
                                    },
                                    "comment": ""
                                })
                                .then(res => {
                                    if(res.data.response.result_code == "true") {
                                        host = res.data.response.data.host;
                                        dir = res.data.response.data.dir;
                                        file_name = res.data.response.data.file_name;
                                        const new_params = {
                                            'key': dir + file_name,
                                            'OSSAccessKeyId': res.data.response.data.accessid,
                                            'policy': res.data.response.data.policy,
                                            'signature': res.data.response.data.signature,
                                            'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                        };
                                        up.setOption({
                                            'url': host,
                                            'multipart_params': new_params
                                        });

                                        // 上传文件
                                        uploader.start();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data.response.error_msg);
                                    }
                                })
                                .catch(err => {
                                    layer.msg("出错啦");
                                });
                            },
                            // 文件上传成功触发
                            FileUploaded: function(up, file, data) {
                                _this.dtj_edit_form.goods[index].img = host + "/" + dir + file_name;
                                _this.dtj_edit_form.goods[index].img_done = true;
                                layer.msg('上传成功');
                            },
                            // 错误提示
                            Error: function(up, err) {
                                if(err.code == -600) {
                                    layer.msg('请选择2mb以内的文件');
                                } else if (err.code == -601) {
                                    layer.msg('只允许上传jpg,jpeg,png,gif文件');
                                } else if (err.code == -602) {
                                    layer.msg('这个文件已经上传过一遍了');
                                } else {
                                    layer.msg(err.response);
                                }
                            }
                        }
                    });
                    // 初始化
                    uploader.init();
                }, 20);
            },
            // 新增、修改
            dtjEdit() {
                const _this = this;

                let url = 'ScreenSkin/addRecommendGoodsData'
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": _this.dtj_edit_form.shop_id,
                            "listorder": _this.dtj_edit_form.listorder,
                            "all_room": _this.dtj_use_all_room,
                            "room_ids": _this.dtj_room_item,
                            "use_every_day": _this.dtj_use_every_day,
                            "start_date": _this.dtj_usedate_start,
                            "end_date": _this.dtj_usedate_end,
                            "start_time": _this.dtj_usetime_start,
                            "end_time": _this.dtj_usetime_end,
                            "week_cycle": _this.dtj_week_ids,
                            "goods": _this.dtj_edit_form.goods
                        }
                    },
                    "comment": ""
                };
                if(_this.dtj_edit_id) {
                    url = 'ScreenSkin/editRecommendGoodsData'
                    data.request.param.id = _this.dtj_edit_id;
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.dtjTable(_this.dtj_page);
                        _this.showDtjList = true;
                        _this.showDtjEdit = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            dtjBackList() {
                this.showDtjList = true;
                this.showDtjEdit = false;
            },

            /*
             * 触摸屏点单热搜词设置
             */
            // 列表
            drcTable: function(page) {
                const _this = this;

                _this.loading = true;
                _this.drc_page = page
                Vue.axios.post('ScreenSkin/getSearchKeywordsList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.drc_list_form.shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.drc_total = Number(res.data.response.result.total);
                        }
                        _this.drc_table = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 禁用启用
            drcStatus(row) {
                const _this = this;

                layer.confirm('确定'+ (row.status == '1' ? '禁用' : '启用') +'吗？', {
                    btn: ['确定', '取消']
                }, function() {
                    Vue.axios.post('ScreenSkin/updateSearchKeywordsStatus', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": row.id,
                                "status": -row.status
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.drcTable(_this.drc_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },
            // 删除
            drcDel(id) {
                const _this = this;

                layer.confirm('删除后不可恢复，确定删除吗？', {
                    btn: ['确定', '取消']
                }, function() {
                    Vue.axios.post('ScreenSkin/delSearchKeywordsData', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "id": id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.msg('删除成功');
                            _this.drcTable(_this.drc_page);
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },
            // 点击新增
            drcAdd() {
                const _this = this
                _this.drc_edit_id = ''
                _this.drc_edit_tit = '新增热搜词'
                _this.drc_edit_form = {
                    shop_id: _this.shop_list[0].id,
                    listorder: '',
                    keywords: ['']
                }
                new Promise(resolve => {
                    _this.drcRoomList(_this.drc_edit_form.shop_id, resolve)
                })
                .then(res => {
                    _this.drc_use_all_room = -1
                    _this.drc_room_txt = ''
                    _this.drc_room_item = []
                })
                _this.drc_usedate_txt = ''
                _this.drc_use_every_day = -1
                $(".drc-usedate-everyday input").val("");
                $(".drc-usedate-everyday input").prop("checked", false);
                _this.drc_usedate_start = ''
                _this.drc_usedate_end = ''
                _this.drc_usetime_txt = ''
                _this.drc_usetime_start = ''
                _this.drc_usetime_end = ''
                _this.drc_week_txt = ''
                _this.drc_week_ids = []
                _this.drc_week_sign = false
                _this.drc_week_all = false
                _this.showDrcList = false
                _this.showDrcEdit = true
            },
            // 点击修改
            drcModify(row) {
                const _this = this

                _this.drc_edit_id = row.id
                _this.drc_edit_tit = '修改热搜词'
                _this.drc_edit_form = {
                    shop_id: row.shop_id,
                    listorder: row.listorder,
                    keywords: row.keywords || ['']
                }
                new Promise(resolve => {
                    _this.drcRoomList(_this.drc_edit_form.shop_id, resolve)
                }).then(res => {
                    _this.drc_use_all_room = row.all_room
                    _this.drc_room_txt = row.room_names
                    _this.drc_room_item = row.room_ids.split(',')
                })
                _this.drc_use_every_day = row.use_every_day
                _this.drc_usedate_start = row.start_date
                _this.drc_usedate_end = row.end_date
                if(row.use_every_day == 1) {
                    $(".drc-usedate-everyday input").val("1");
                    $(".drc-usedate-everyday input").prop("checked", true);
                    _this.drc_usedate_txt = '每天'
                } else {
                    $(".drc-usedate-everyday input").val("");
                    $(".drc-usedate-everyday input").prop("checked", false);
                    _this.drc_usedate_txt = row.start_date + '~' + row.end_date
                }
                _this.drc_usetime_txt = row.start_time + '~' + row.end_time
                _this.drc_usetime_start = row.start_time
                _this.drc_usetime_end = row.end_time
                _this.drc_week_ids = row.week_cycle
                _this.drc_week_sign = _this.drc_week_ids.length > 0 && _this.drc_week_ids.length < _this.week_list.length;
                _this.drc_week_all = _this.drc_week_ids.length === _this.week_list.length;
                let week_txt = [];
                _this.week_list.forEach(_ => {
                    _this.drc_week_ids.forEach(item => {
                        if(_.id == item) {
                            week_txt.push(_.name);
                        }
                    });
                });
                _this.drc_week_txt = week_txt.join(',');
                _this.showDrcList = false
                _this.showDrcEdit = true
            },
            drcShopChange(val) {
                console.log(val);
                
                new Promise(resolve => {
                    this.drcRoomList(val, resolve)
                })
                this.drc_use_all_room = -1
                this.drc_room_txt = '';
                this.drc_room_item = [];
            },
            // 获取包厢号
            drcRoomList: function(shop_id, resolve) {
                const _this = this;

                Vue.axios.post('Shop/getAllRoomByArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.drc_room_arr = res.data.response.result;
                        _this.drc_room_arr_det = [];
                        res.data.response.result.forEach(_ => {
                            _.room.forEach(item => _this.drc_room_arr_det.push(item))
                        });
                        resolve();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 点击选择包厢号
            drcRoomSelect: function(e) {
                this.drc_c_room_item = [...this.drc_room_item]
                this.showDrcEdit = false
                this.showDrcRoom = true
            },
            drcRoomDel() {
                this.drc_use_all_room = -1
                this.drc_room_txt = ''
                this.drc_room_item = []
            },
            // 全选
            drcRoomAll: function() {
                const _this = this;

                if(!_this.drc_room_all) { // 实现全选
                    _this.drc_room_item = [];
                    _this.drc_room_arr_det.forEach(item => {
                        _this.drc_room_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.drc_room_item = [];
                }
            },
            // 楼层全选/反选
            drcRoomFloor: function(id, index) {
                const _this = this;

                if(_this.drc_room_floor.indexOf(id) == -1) {
                    _this.drc_room_arr[index].room.forEach(item => {
                        if(_this.drc_room_item.indexOf(item.id) == -1) {
                            _this.drc_room_item.push(item.id);
                        }
                    });
                } else {
                    _this.drc_room_arr[index].room.forEach(item => {
                        let index = '';
                        index = _this.drc_room_item.indexOf(item.id);
                        if(index != -1) {
                            _this.drc_room_item.splice(index, 1);
                        }
                    });
                }
            },
            // 确定包厢
            drcRoomSave: function() {
                const _this = this;

                if(_this.drc_room_all) {
                    _this.drc_room_txt = '全部'
                    _this.drc_use_all_room = 1
                } else {
                    let texts = [];
                    _this.drc_room_arr_det.forEach(_ => {
                        _this.drc_room_item.forEach(item => {
                            if(_.id == item) {
                                texts.push(_.name);
                            }
                        });
                    });
                    _this.drc_room_txt = texts.join(",");
                    _this.drc_use_all_room = -1;
                }
                _this.showDrcEdit = true
                _this.showDrcRoom = false
            },
            // 返回
            drcRoomBack: function() {
                this.drc_room_item = [...this.drc_c_room_item]
                this.showDrcEdit = true
                this.showDrcRoom = false
            },
            drcUsetime: function() {
                const _this = this;

                _this.drc_hour_start = _this.drc_usetime_start.split(':')[0] || '00'
                _this.drc_minute_start = _this.drc_usetime_start.split(':')[1] || '00'
                _this.drc_hour_end = _this.drc_usetime_end.split(':')[0] || '00'
                _this.drc_minute_end = _this.drc_usetime_end.split(':')[1] || '00'
                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin',
                    btn: ['确定', '取消'], // 按钮
                    title: '使用时间',
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.drc_usetime_alert)
                }, function() {
                    _this.drc_usetime_start = _this.drc_hour_start + ":" + _this.drc_minute_start
                    _this.drc_usetime_end = _this.drc_hour_end + ":" + _this.drc_minute_end
                    _this.drc_usetime_txt = _this.drc_usetime_start + " ~ " + _this.drc_usetime_end
                    layer.closeAll();
                });
            },
            // 星期
            drcWeekSelect() {
                const _this = this;
                const c_week_ids = _this.drc_week_ids,
                    c_week_sign = _this.drc_week_sign,
                    c_week_all = _this.drc_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.drc_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.drc_week_ids = c_week_ids;
                        _this.drc_week_sign = c_week_sign;
                        _this.drc_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.drc_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.drc_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.drc_week_ids = c_week_ids;
                    _this.drc_week_sign = c_week_sign;
                    _this.drc_week_all = c_week_all;
                });
            },
            drcWeekDel() {
                this.drc_week_sign = false;
                this.drc_week_all = false;
                this.drc_week_ids = [];
            },
            drcWeekAll(val) {
                let ids = [];
                this.week_list.forEach(v => {
                    ids.push(v.id);
                });
                this.drc_week_ids = val ? ids : [];
                this.drc_week_sign = false;
            },
            drcWeekChange(val) {
                const len = val.length;
                this.drc_week_sign = len > 0 && len < this.week_list.length;
                this.drc_week_all = len === this.week_list.length;
            },
            // 新增商品
            drcImgAdd: function() {
                this.drc_edit_form.keywords.push('')
            },
            // 删除商品
            drcImgDel: function(num) {
                this.drc_edit_form.keywords.splice(num, 1)
            },
            // 新增、修改
            drcEdit() {
                const _this = this;

                let url = 'ScreenSkin/addSearchKeywordsData'
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": _this.drc_edit_form.shop_id,
                            "listorder": _this.drc_edit_form.listorder,
                            "all_room": _this.drc_use_all_room,
                            "room_ids": _this.drc_room_item,
                            "use_every_day": _this.drc_use_every_day,
                            "start_date": _this.drc_usedate_start,
                            "end_date": _this.drc_usedate_end,
                            "start_time": _this.drc_usetime_start,
                            "end_time": _this.drc_usetime_end,
                            "week_cycle": _this.drc_week_ids,
                            "keywords": _this.drc_edit_form.keywords
                        }
                    },
                    "comment": ""
                };
                if(_this.drc_edit_id) {
                    url = 'ScreenSkin/editSearchKeywordsData'
                    data.request.param.id = _this.drc_edit_id;
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        _this.drcTable(_this.drc_page);
                        _this.showDrcList = true;
                        _this.showDrcEdit = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            drcBackList() {
                this.showDrcList = true;
                this.showDrcEdit = false;
            },
            // 触摸屏包厢账单是否显示送花结账单设置列表
            innitFlowerTable() {
                let _this = this;
                $(_this.$refs.flowerList).bootstrapTable('destroy');
                $(_this.$refs.flowerList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.commonGetConfigList(params, 'merge_flower_data');
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "50%"
                    }, {
                        field: "merge_flower_screen",
                        title: "触摸屏包厢账单是否显示送花结账单",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.commonConfigSet(row.shop_id, 'merge_flower_screen', check_stock, 'flowerList');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if (row.merge_flower_screen == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 大厅自助台球语音播报设置列表
            ballVoiceTable: function(page) {
                const _this = this;

                _this.loading = true;
                _this.ball_voice_page = page
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "config_type": "self_service_billiards_setting"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.ball_voice_total = Number(res.data.response.result.count);
                        }
                        _this.ball_voice_table = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 语音播报设置
            ballVoiceChange(row){
                let _this = this;
                if(row.self_service_billiards_setting.audio_broadcast_status == '1'){
                    // 开启语音播报 需要先设置播放设备
                    console.log('row',row);
                    
                    if(row.self_service_billiards_setting.audio_play_device != '0'){
                        // 播放设备不为空，则发请求
                        _this.commonEditBilliardsSetting(row);
                        
                    }else{
                        // 播放设备为空，则提示
                        row.self_service_billiards_setting.audio_broadcast_status = '-1'
                        this.showDeviceModal = true;
                        this.currentRow = row;
                    }
                }else{
                    // 关闭语音播报，直接发请求关闭
                    _this.commonEditBilliardsSetting(row);
                }
            },
            // 保存播放设备
            ballVoiceDeviceSave(){
                console.log('this.selected_row',this.selected_row);
                this.commonEditBilliardsSetting(this.selected_row);
            },

            // 播放内容设置
            ballContentEdit(row){
                console.log(row);
                this.selected_row = row;
                this.show11_content = true;
                this.show11_list = false;
            },
            // 播放设备设置
            ballDeviceEdit(row){
                console.log(row);
                this.selected_row = row;
                this.show11_device = true;
                this.show11_list = false;
                this.getRoomListByShopId(row.shop_id);
            },

            // 获取包厢列表
            getRoomListByShopId(shop_id){
                let _this = this;
               Vue.axios.post('Shop/getAllRoom', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": shop_id
                    }
                },
                "comment": ""
               })
               .then(res => {
                console.log('API响应数据:', res.data);
                if(res.data.response.result_code == "true"){
                    _this.room_list = res.data.response.result || [];
                }else{
                    Vue.timeoutfun(res.data.response.result_status, _this);
                }
               })
               .catch(err => {
                layer.msg("出错啦");
               });
            },

            // 返回列表
            backToList(){
                this.show11_device = false;
                this.show11_content = false;
                this.show11_list = true;
                this.room_list = [];
                this.selected_row = {
                    self_service_billiards_setting:{
                        audio_broadcast_status: "-1", // 语音播报，1：开启，-1：关闭
                        audio_play_device: "36", // 语音播报播放设备，包厢id
                        audio_content: { // 语音播放内容设置
                            volume: "50", // 音量
                            open_audio_status: "1", // 开台播报，1：开启，-1：关闭
                            open_audio_content: "欢迎来到{shop_name}，您已成功开启{room_name}号台", // 开台播报内容
                            renewal_audio_status: "1", // 续费播报，1：开启，-1：关闭
                            renewal_audio_time: [10,5], // 剩余时间提醒，多选，数组
                            renewal_audio_content: "温馨提示:您使用的{room_name}号台,剩余游戏时间不足{remaining_time},请合理安排局数,准备离场。如需续时,请扫描桌面二维码,感谢您的使用,祝您打球愉快", // 续费播报内容
                            close_audio_status: "1", // 关台播报，1：开启，-1：关闭
                            close_audio_content: "温馨提示:您使用的{room_name}号台,游戏时间已结束。感谢您的使用,欢迎再次光临{shop_name}" // 关台播报内容
                        }
                    },
                };
                // 刷新列表
                this.ballVoiceTable(this.ball_voice_page);
            },

            // 关闭播放设备设置弹窗
            closeDeviceModal(){
                this.showDeviceModal = false;
                this.currentRow = null;
            },

            // 前往播放设备设置
            goToDeviceSetting(){
                if(this.currentRow) {
                    this.ballDeviceEdit(this.currentRow);
                    this.closeDeviceModal();
                }
            },

            ballVoiceContentSave(){
                console.log('this.selected_row',this.selected_row);
                this.commonEditBilliardsSetting(this.selected_row);
            },

            // 通用修改台球设置
            commonEditBilliardsSetting(row){
                let _this = this;
                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": row.shop_id,
                            "config_type": "self_service_billiards_setting",
                            "config": row.self_service_billiards_setting
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true"){
                        layer.msg('设置成功');
                        _this.ballVoiceTable(_this.ball_voice_page);
                    }else{
                        Vue.timeoutfun(res.data.response.result_status, _this);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            addVariable(variable, type){
                console.log(variable, type);
                this.selected_row.self_service_billiards_setting.audio_content[type] += variable;
            },

            // 通用设置列表
            commonGetConfigList(params, config_type) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": config_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 通用设置
            commonConfigSet(id, config_type, check_stock, ref) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config_type": config_type,
                            "config": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs[`${ref}`]).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
        },
    }
</script>
<style lang="less" scoped>
    .selection_clear {
        display: none;
        position: absolute;
        right: 36px;
        top: 1px;
        width: 20px;
        height: 32px;
        line-height: 32px;
        font-weight: bold;
        cursor: pointer;
    }
    .printer_arrow {
        height: 32px;
        position: absolute;
        top: 1px;
        right: 16px;
        width: 20px;
        cursor: pointer;
        b {
            border-color: #888 transparent transparent transparent;
            border-style: solid;
            border-width: 5px 4px 0 4px;
            height: 0;
            left: 50%;
            margin-left: -4px;
            margin-top: -2px;
            position: absolute;
            top: 50%;
            width: 0;
        }
    }
    .rowpadding {
        margin: 0 0 36px;
    }

    // 包厢后买单设置
    .store-room-set {
        .room-modify {
            display: none;
            width: 100%;
            height: 100%;
            padding: 30px 20px;
            font-size: 14px;
            >p {
                text-align: center;
            }
        }
    }

    // 触摸屏wifi显示设置
    .store-wifi-set {
        .wifi-list {
            table {
                table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .visi_hid {
            width: 0;
            opacity: 0;
        }
        .box-page {
            .box-main {
                width: 80%;
                border: 1px solid #e5e5e5;
                margin-top: 20px;
            }
            .box-area {
                position: relative;
                display: block;
                width: 100%;
                margin: 0 auto;
                .first {
                    width: 100%;
                    padding-left: 30px;
                    border:none;
                    line-height: 32px;
                    background: #f5f5f5;
                }
                ul {
                    padding: 10px 30px 20px 54px;
                    border: none;
                    margin-bottom: 0px;
                }
                li {
                    overflow: hidden;
                    float: left;
                    width: 14.28%;
                    height: 32px;
                    line-height: 32px;
                    color: #a29d9d;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                input {
                    margin: 0 6px 0 0;
                }
            }
        }
    }

    // 触摸屏屏保设置
    .store-scrn-set {
        .scrn-set {
            >p {
                margin: 0 0 30px;
                color: #FF0707;
            }
        }
        .scrn-hp-list, .scrn-sp-list {
            float: left;
            margin: 10px 0 0;
            li {
                position: relative;
                float: left;
                width: 180px;
                height: 101px;
                margin: 30px 0 0 30px;
                >img {
                    position: absolute;
                    right: -11px;
                    top: -11px;
                    cursor: pointer;
                }
                div img {
                    display: block;
                    width: 180px;
                    height: 101px;
                    cursor: pointer;
                }
                span {
                    display: none;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 55px;
                    height: 16px;
                    color: #FFF;
                    text-align: center;
                    background: #009af0;
                    cursor: pointer;
                }
            }
            .uploadinput {
                display: none;
            }
        }
        .scrn-hp-add, .scrn-sp-add {
            float: left;
            margin: 40px 0 0 30px;
            cursor: pointer;
        }
        .scrn-sp-list {
            li {
                width: 101px;
                height: 180px;
                div img {
                    width: 101px;
                    height: 180px;
                }
            }
        }
    }
    .big-hp, .big-sp {
        display: none;
    }
    .big-hp img {
        display: block;
        width: 889px;
        height: 500px;
        margin: 30px auto 0;
    }
    .big-sp img {
        display: block;
        width: 281px;
        height: 500px;
        margin: 30px auto 0;
    }
    .store-big {
        .layui-layer-btn {
            display: none;
        }
    }

    // 触摸屏呼叫服务设置
    .store-chf-set {
        .chf-modify {
            display: none;
            .chf-modify-shop {
                line-height: 32px;
                background: #DDD;
            }
            .chf-txt-add {
                overflow: hidden;
                div {
                    width: 555px;
                    padding: 0;
                    margin: 0 15px 0 0;
                }
                img {
                    cursor: pointer;
                }
            }
            .chf-txt-wrap {
                overflow: hidden;
                margin: 36px 0 0 120px;
                div {
                    width: 555px;
                    padding: 0;
                    margin: 0 15px 0 0;
                }
                img {
                    cursor: pointer;
                }
            }
            .chf-sel-list {
                padding: 0;
                border: 1px solid #CCC;
                ul {
                    margin: 50px 0 30px;
                }
                li {
                    float: left;
                    width: 90px;
                    border: 1px solid #CCC;
                    margin: 0 0 20px 17px;
                    line-height: 30px;
                    color: #757575;
                    text-align: center;
                    cursor: pointer;
                    border-radius: 15px;
                }
            }
        }
    }

    // disco限制播放时间设置
    .store-disco-set {
        .disco-list {
            h1 {
                margin: 0 0 20px;
            }
            p {
                color: #FF0707;
                margin: 0;
            }
        }
        .disco-modify {
            display: none;
            padding: 30px 60px;
            div {
                margin: 0 0 20px;
                label {
                    margin: 0 0 0 3px;
                    color: #666;
                    font-size: 16px;
                    font-weight: normal;
                }
            }
        }
    }

    // 网关检测设置
    .store-wg-set {
        .wg-list {
            h1 {
                margin: 0 0 20px;
            }
            p {
                color: #FF0707;
                margin: 0;
            }
        }
        .wg-edit {
            display: none;
            width: 70%;
            margin: 30px auto;
            p {
                line-height: 32px;
                font-size: 14px;
            }
            textarea {
                display: block;
                resize: none;
                width: 100%;
                height: 80px;
            }
        }
    }
    // 触摸屏点单推荐设置
    .dtj-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .dtj-usedate-wrap {
                position: relative;
            }
            .dtj-usedate-main {
                width: 400px;
            }
        }
        .dtj-edit-goods {
            width: 400px;
            padding: 20px;
            margin: 0 0 30px;
            background: #f5f5f5;
            p {
                float: left;
                margin-right: 20px;
                color: #f00;
            }
            i {
                color: #409eff;
                font-size: 40px;
                cursor: pointer;
            }
            img {
                clear: both;
                display: block;
                width: 114px;
                height: 114px;
                margin: 0 0 20px;
                cursor: pointer;
            }
            .el-input {
                width: 230px;
            }
        }
    }
    .select-goods-wrap {
        display: none;
    }

    // 触摸屏点单热搜词设置
    .drc-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .drc-usedate-wrap {
                position: relative;
            }
            .drc-usedate-main {
                width: 400px;
            }
        }
        .drc-edit-goods {
            margin: 0 0 20px;
            i {
                vertical-align: bottom;
                color: #409eff;
                font-size: 40px;
                cursor: pointer;
            }
        }
    }
    .room-selection{
        background-color: #f5f5f5; 
        margin-bottom: 20px; 
        padding: 20px; 
        margin-top: 20px; 
        border-radius: 5px;
    }
    .room-selection-title{
        margin-top: 0; 
        margin-bottom: 15px;
    }
    // 包厢机顶盒设备选择样式
    .room-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        align-items: flex-start;
    }

    .room-radio-item {
        width: calc(16.666% - 12.5px); // 6 items per row (100% / 6) minus gap adjustment
        min-width: 120px;
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        
        .el-radio__label {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
        }
    }

    // 播放设备设置弹窗样式
    .device-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }

    .device-modal {
        background: #f5f5f5;
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    }

    .device-modal-header {
        padding: 20px 20px 10px;
        text-align: center;
        border-bottom: 1px solid #e0e0e0;

        h3 {
            margin: 0;
            color: #333;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .device-modal-body {
        padding: 20px;
        text-align: center;

        p {
            margin: 5px 0;
            color: #333;
            font-size: 14px;
            line-height: 1.5;
        }
    }

    .device-modal-footer {
        padding: 10px 20px 20px;
        display: flex;
        justify-content: center;
        gap: 15px;
    }

    .device-modal-btn {
        padding: 8px 20px;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        min-width: 80px;
        transition: all 0.3s ease;

        &.device-modal-btn-cancel {
            background: white;
            color: #333;
            border: 1px solid #ccc;

            &:hover {
                background: #f0f0f0;
            }
        }

        &.device-modal-btn-confirm {
            background: #409eff;
            color: white;

            &:hover {
                background: #337ecc;
            }
        }
    }
    .ball-voice-content-list{
        display: flex;
    }
    .ball-voice-content-item{
        width: 100%;
        background-color:#d7d7d7;
        display: flex;
        flex-direction: column;
        padding: 10px;
        margin-bottom: 20px;
    }
    .ball-voice-content-item-header{
        display: flex;
        gap: 10px;
        align-items: center;
    }
    .ball-voice-content-item-content{
        display: flex;
        
        .el-textarea {
            .el-textarea__inner {
                min-height: 300px !important;
                height: auto !important;
                resize: vertical;
            }
        }
    }
    .ball-voice-content-item-footer{
        display: flex;
        gap: 10px;
        align-items: center;
    }
    
    .renewal-time-settings {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
        width: 100%;
    }
    
    .renewal-time-label {
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
        font-weight: 500;
    }
    
    .renewal-time-options {
        .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
        }
        
        .el-checkbox {
            margin-right: 0;
        }
    }
    
    .ball-voice-content-item-content {
        display: flex;
        flex-direction: column;
        
        .el-textarea {
            .el-textarea__inner {
                min-height: 300px !important;
                height: auto !important;
                resize: vertical;
            }
        }
    }
</style>